var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _g, _path73, _g2, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 282,
    viewBox: "0 0 282 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 141,
    cy: 141,
    r: 141,
    fill: "#A7A6CE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.155 136.886c-5.918-8.993-18.462-13.812-18.79-27.288-.124-5.103 3.421-9.203 1.826-14.207-10.702-33.567-61.254-10.562-83.088-3.468-9.091 2.954-19.968 6.244-29.743 5.813-11.254-.496-21.71-6.309-32.849-7.4-3.431-.335-6.638-.047-9.636.789-11.24 3.133-21.165 14.9-24.902 27.973-3.03 10.597.84 21.058-3.916 31.435-5.07 11.061-15.055 18.744-17.57 31.514-3.02 15.326 8.516 28.654 20.907 29.071 7.888.265 22.508-1.106 29.208-6.402 8.16-6.449 16.178-6.873 25.69-6.626 18.101.47 36.201 4.903 54.069 8.059 15.311 2.705 30.401 6.71 45.918 7.218 11.395.374 21.066.542 27.232-12.928 7.37-16.1 28.059-44.688 15.644-63.553",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.59 211.607c.088.995-.869 1.758-1.823 1.462-5.264-1.634-19.732-7.599-26.817-25.26-5.984-14.914-10.646-22.433-12.999-25.699-.497-.691.176-1.615.987-1.355 8.942 2.871 37.441 14.795 40.651 50.852",
    fill: "#91B3FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.035 212.329a.34.34 0 0 1-.234-.091c-.18-.164-18.107-16.721-27.36-37.074a.346.346 0 1 1 .63-.286c9.196 20.226 27.018 36.686 27.197 36.85a.346.346 0 0 1-.234.601",
    fill: "#DCE5FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M205.04 104.294c1.48 11.907 8.884 85.325-30.163 108.752-1.183.709-2.699-.08-2.799-1.455-.634-8.751-1.029-36.559 15.031-69.378 11.588-23.679 15.835-34.354 17.174-38.005.142-.387.706-.322.757.086",
    fill: "#BDD0FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M172.078 211.822a.23.23 0 0 1-.202-.341c19.815-36.429 28.184-80.262 28.032-81.464a.22.22 0 0 1 .153-.28c.122-.039.254.038.292.16.2.64-2.137 12.684-6.477 27.62-4.12 14.183-11.212 35.096-21.595 54.185a.23.23 0 0 1-.203.12",
    fill: "#DCE5FE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.692 101.398c-1.24 9.979-7.446 71.512 25.281 91.147a1.552 1.552 0 0 0 2.346-1.219c.53-7.335.862-30.641-12.598-58.148-9.712-19.846-13.272-28.792-14.394-31.853-.119-.324-.592-.269-.635.073",
    fill: "#BDD0FB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.318 191.557a.23.23 0 0 1-.203-.121c-8.704-16.002-14.648-33.532-18.102-45.42-3.707-12.756-5.602-22.616-5.428-23.171a.23.23 0 0 1 .445.121c-.047.584 1.636 9.927 5.509 23.205 3.438 11.789 9.35 29.174 17.982 45.045a.23.23 0 0 1-.203.341",
    fill: "#DCE5FE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M178.215 210.725c7.89 1.016 30.977.53 37.101-38.212.174-1.101-1.22-1.72-1.915-.85-3.254 4.078-9.06 11.027-14.213 13.374-15.967 7.271-21.264 17.706-22.926 22.543a2.386 2.386 0 0 0 1.953 3.145",
    fill: "#BDD0FB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M177.374 209.707a.346.346 0 0 1-.117-.672c11.183-4.017 19.151-10.903 23.866-15.971 5.115-5.499 7.613-10.107 7.638-10.153a.345.345 0 0 1 .61.327c-.025.047-2.555 4.718-7.725 10.28-4.769 5.131-12.831 12.101-24.155 16.168a.4.4 0 0 1-.117.021",
    fill: "#DCE5FE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m98.093 85.5 77.226.85c4.269.047 7.617 3.73 7.614 8.358l-.069 114.475c-.001 3.203-2.594 5.859-5.722 5.872l-82.793.366c-2.922.013-5.318-2.43-5.318-5.43V95.264c0-5.436 4.057-9.82 9.062-9.764",
    fill: "url(#b)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M168.881 96.616h-64.914c-2.722 0-5.08 2.1-5.08 4.753v94.477c0 2.652 2.358 4.85 5.08 4.85h64.914c2.722 0 4.777-2.198 4.777-4.85v-94.477c0-2.652-2.055-4.753-4.777-4.753",
    fill: "url(#c)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M132.454 176.979v-4.158c-4.335-.174-8.622-1.197-11.667-2.53-1.087-.476-1.642-1.696-1.329-2.841l1.056-3.874c.387-1.42 1.933-2.155 3.291-1.586 3.02 1.266 6.75 2.268 10.772 2.268 4.175 0 7.288-1.415 7.288-4.317 0-2.618-2.405-4.174-8.208-5.731-8.279-2.264-14.223-5.873-14.223-13.162 0-6.581 4.812-11.605 13.162-12.949v-4.159a2.42 2.42 0 0 1 2.422-2.422h2.443a2.42 2.42 0 0 1 2.423 2.422v3.734c4.011.16 6.931.846 9.248 1.66 1.187.418 1.836 1.696 1.506 2.911l-.971 3.582a2.416 2.416 0 0 1-3.19 1.631c-2.133-.806-5.149-1.646-9.07-1.646-4.953 0-6.368 2.052-6.368 3.892 0 2.264 2.972 3.821 9.411 5.802 9.199 2.76 13.02 6.581 13.02 13.445 0 6.298-4.67 11.959-13.727 13.374v4.654a2.42 2.42 0 0 1-2.423 2.422h-2.443a2.42 2.42 0 0 1-2.423-2.422",
    fill: "url(#d)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M191.288 164.442c-.236 8.434-1.002 37.525-.636 47.834.039 1.092 1.028 1.968 2.261 2.004 6.101.177 28.468.625 38.447.254 2.078-.077 3.731-1.567 3.775-3.409.207-8.852.664-33.75-.423-45.156-.13-1.367-1.342-2.455-2.883-2.591-6.645-.589-29.107-2.027-37.729-1.532-1.555.09-2.773 1.217-2.812 2.596",
    fill: "url(#e)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M194.011 166.406c-.328 1.972-1.364 8.529-1.035 10.954.048.355 1.137.641 2.518.662 5.686.085 25.085.273 33.425.102 1.502-.031 2.68-.342 2.761-.728.423-2.011 1.637-8.117 1.321-10.515-.05-.382-1.206-.695-2.693-.729-6.151-.141-26.765-.478-33.851-.379-1.331.018-2.389.292-2.446.633",
    fill: "url(#f)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M230.412 168.12a1.63 1.63 0 0 0-1.15-.499l-31.953-.508a1.637 1.637 0 0 0-1.655 1.484l-.664 7.088c-.054.581.901 1.07 2.118 1.084l31.414.381c1.216.015 2.221-.449 2.231-1.029l.118-6.836a1.63 1.63 0 0 0-.459-1.165",
    fill: "#91B3FA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M201.348 185.027a2.283 2.283 0 0 1-2.283 2.283h-2.819a2.283 2.283 0 0 1-2.283-2.283v-.05a2.283 2.283 0 0 1 2.283-2.283h2.819a2.284 2.284 0 0 1 2.283 2.283z",
    fill: "url(#g)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M211.734 185.027a2.283 2.283 0 0 1-2.283 2.283h-2.818a2.283 2.283 0 0 1-2.283-2.283v-.05a2.283 2.283 0 0 1 2.283-2.283h2.818a2.283 2.283 0 0 1 2.283 2.283z",
    fill: "url(#h)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M221.656 185.027a2.283 2.283 0 0 1-2.283 2.283h-2.818a2.284 2.284 0 0 1-2.284-2.283v-.05a2.284 2.284 0 0 1 2.284-2.283h2.818a2.283 2.283 0 0 1 2.283 2.283z",
    fill: "url(#i)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M231.889 185.371a2.32 2.32 0 0 1-2.32 2.32h-2.686a2.32 2.32 0 1 1 0-4.64h2.686a2.32 2.32 0 0 1 2.32 2.32",
    fill: "url(#j)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M201.348 192.181a2.283 2.283 0 0 1-2.283 2.283h-2.819a2.283 2.283 0 0 1-2.283-2.283v-.049a2.283 2.283 0 0 1 2.283-2.283h2.819a2.283 2.283 0 0 1 2.283 2.283z",
    fill: "url(#k)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M211.734 192.181a2.283 2.283 0 0 1-2.283 2.283h-2.818a2.283 2.283 0 0 1-2.283-2.283v-.049a2.283 2.283 0 0 1 2.283-2.283h2.818a2.283 2.283 0 0 1 2.283 2.283z",
    fill: "url(#l)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M221.656 192.181a2.283 2.283 0 0 1-2.283 2.283h-2.818a2.284 2.284 0 0 1-2.284-2.283v-.049a2.284 2.284 0 0 1 2.284-2.283h2.818a2.283 2.283 0 0 1 2.283 2.283z",
    fill: "url(#m)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M232.041 192.181a2.283 2.283 0 0 1-2.283 2.283h-2.819a2.283 2.283 0 0 1-2.283-2.283v-.049a2.283 2.283 0 0 1 2.283-2.283h2.819a2.283 2.283 0 0 1 2.283 2.283z",
    fill: "url(#n)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M201.348 199.104a2.283 2.283 0 0 1-2.283 2.283h-2.819a2.283 2.283 0 0 1-2.283-2.283v-.049a2.284 2.284 0 0 1 2.283-2.284h2.819a2.284 2.284 0 0 1 2.283 2.284z",
    fill: "url(#o)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M211.734 199.104a2.283 2.283 0 0 1-2.283 2.283h-2.818a2.283 2.283 0 0 1-2.283-2.283v-.049a2.284 2.284 0 0 1 2.283-2.284h2.818a2.284 2.284 0 0 1 2.283 2.284z",
    fill: "url(#p)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M221.656 199.104a2.283 2.283 0 0 1-2.283 2.283h-2.818a2.284 2.284 0 0 1-2.284-2.283v-.049a2.285 2.285 0 0 1 2.284-2.284h2.818a2.284 2.284 0 0 1 2.283 2.284z",
    fill: "url(#q)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M201.348 206.028a2.283 2.283 0 0 1-2.283 2.283h-2.819a2.283 2.283 0 0 1-2.283-2.283v-.05a2.283 2.283 0 0 1 2.283-2.283h2.819a2.284 2.284 0 0 1 2.283 2.283z",
    fill: "url(#r)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M211.734 206.028a2.283 2.283 0 0 1-2.283 2.283h-2.818a2.283 2.283 0 0 1-2.283-2.283v-.05a2.283 2.283 0 0 1 2.283-2.283h2.818a2.283 2.283 0 0 1 2.283 2.283z",
    fill: "url(#s)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M221.656 206.028a2.283 2.283 0 0 1-2.283 2.283h-2.818a2.284 2.284 0 0 1-2.284-2.283v-.05a2.284 2.284 0 0 1 2.284-2.283h2.818a2.283 2.283 0 0 1 2.283 2.283z",
    fill: "url(#t)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M231.119 205.421a2.89 2.89 0 0 1-2.89 2.89h-.22a2.89 2.89 0 0 1-2.89-2.89v-5.528a2.89 2.89 0 0 1 2.89-2.89h.22a2.89 2.89 0 0 1 2.89 2.89z",
    fill: "url(#u)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M226.966 169.08a.46.46 0 0 1-.462.461h-1.384a.461.461 0 1 1 0-.923h1.384c.255 0 .462.207.462.462m0 6.924a.46.46 0 0 1-.462.461h-1.384a.462.462 0 1 1 0-.923h1.384c.255 0 .462.207.462.462m-2.308-4.155a.462.462 0 0 1-.924 0v-1.385a.462.462 0 0 1 .924 0zm0 2.77a.461.461 0 0 1-.924 0v-1.385a.462.462 0 0 1 .924 0zm3.462-2.77a.461.461 0 1 1-.923 0v-1.385a.462.462 0 0 1 .923 0zm0 2.77a.46.46 0 1 1-.923 0v-1.385a.462.462 0 0 1 .923 0z",
    opacity: 0.7,
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m162.275 194.733.52 16.147c.09 2.816 2.401 5.056 5.231 5.073l38.668.228a3.79 3.79 0 0 0 3.779-3.226c.605-4.078 1.375-11.374.508-18.223z",
    fill: "url(#v)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M205.895 215.257a.115.115 0 0 1-.115-.111.117.117 0 0 1 .111-.12 3.5 3.5 0 0 0 .663-.088.116.116 0 0 1 .053.225 4 4 0 0 1-.707.094zm-1.615-.006h-.001l-.692-.004a.115.115 0 1 1 .001-.231h.001l.692.004a.115.115 0 0 1 .114.116.115.115 0 0 1-.115.115m-2.308-.013-.693-.004a.116.116 0 0 1 .001-.231h.001l.692.004a.115.115 0 1 1-.001.231m-2.307-.014-.692-.004a.116.116 0 0 1-.115-.116c0-.064.052-.115.115-.115h.001l.692.004a.116.116 0 0 1 .115.116.115.115 0 0 1-.115.115m-2.308-.014-.692-.004a.115.115 0 0 1-.115-.116.12.12 0 0 1 .116-.114l.693.004a.115.115 0 0 1-.001.23m-2.308-.013-.692-.004a.117.117 0 0 1-.115-.116.116.116 0 0 1 .116-.115h.001l.692.004c.063 0 .115.052.114.116a.115.115 0 0 1-.115.115m-2.308-.014-.693-.004a.114.114 0 0 1-.114-.116c0-.064.052-.115.115-.115h.001l.692.004a.117.117 0 0 1 .115.116.116.116 0 0 1-.116.115m-2.307-.013-.692-.004a.117.117 0 0 1-.115-.117c0-.063.052-.114.115-.114h.001l.692.004a.115.115 0 0 1 0 .231m-2.308-.014-.692-.004a.115.115 0 1 1 .001-.231l.693.004a.115.115 0 0 1 .114.116.115.115 0 0 1-.115.115m-2.308-.014-.693-.004a.115.115 0 0 1 .001-.23h.001l.692.004a.115.115 0 1 1-.001.23m-2.308-.013-.693-.004a.116.116 0 0 1 .001-.231h.001l.692.004a.115.115 0 1 1-.001.231m-2.307-.014-.692-.004a.115.115 0 1 1 .001-.231l.693.005a.115.115 0 0 1-.001.23m-2.308-.013-.692-.005a.115.115 0 1 1 .001-.23h.001l.692.004a.115.115 0 1 1-.001.231m-2.308-.014-.693-.004a.115.115 0 0 1-.114-.116c0-.064.052-.115.115-.115h.001l.692.004a.117.117 0 0 1 .115.116.116.116 0 0 1-.116.115m-2.307-.014-.692-.004a.115.115 0 0 1-.115-.116c0-.063.06-.106.116-.114l.692.004a.115.115 0 0 1 0 .23m-2.308-.013-.692-.004a.117.117 0 0 1-.115-.116.116.116 0 0 1 .116-.115l.693.004c.063 0 .115.052.114.116a.115.115 0 0 1-.115.115m-2.308-.014-.692-.004a.115.115 0 1 1 .001-.231h.001l.692.004a.117.117 0 0 1 .115.117.116.116 0 0 1-.116.114m-2.28-.258a.1.1 0 0 1-.036-.005 5 5 0 0 1-.655-.269.115.115 0 1 1 .102-.207c.202.1.413.186.625.257a.115.115 0 0 1-.036.224m40.638-.322a.11.11 0 0 1-.09-.044.116.116 0 0 1 .017-.162q.264-.21.481-.466a.114.114 0 0 1 .162-.013.115.115 0 0 1 .013.163q-.23.271-.511.496a.12.12 0 0 1-.072.026m-42.587-.872a.11.11 0 0 1-.082-.034 5 5 0 0 1-.467-.531.116.116 0 0 1 .021-.162.116.116 0 0 1 .162.022q.205.268.447.507a.116.116 0 0 1 .001.164.12.12 0 0 1-.082.034m43.821-1.031-.029-.003a.116.116 0 0 1-.083-.141q.047-.18.074-.363l.045-.306a.114.114 0 0 1 .13-.098.116.116 0 0 1 .098.131l-.045.307q-.029.196-.078.387a.12.12 0 0 1-.112.086m-45.037-.907a.115.115 0 0 1-.109-.078 5 5 0 0 1-.181-.684.116.116 0 0 1 .227-.044q.064.335.172.653a.116.116 0 0 1-.109.153m45.373-1.375-.015-.001a.116.116 0 0 1-.1-.129q.042-.335.082-.687a.116.116 0 0 1 .23.027l-.083.688a.115.115 0 0 1-.114.102m-45.662-.903a.115.115 0 0 1-.115-.111l-.022-.692a.114.114 0 0 1 .111-.119.117.117 0 0 1 .119.111l.022.692a.114.114 0 0 1-.111.119zm45.914-1.392h-.011a.115.115 0 0 1-.104-.126l.063-.689c.005-.063.06-.107.125-.105.063.006.11.062.105.125l-.064.691a.113.113 0 0 1-.114.104m-45.988-.914a.115.115 0 0 1-.115-.112l-.022-.692a.114.114 0 0 1 .111-.119.117.117 0 0 1 .119.112l.022.692a.116.116 0 0 1-.111.119zm46.174-1.386h-.008a.117.117 0 0 1-.107-.123q.023-.342.042-.69a.115.115 0 0 1 .122-.109.116.116 0 0 1 .109.122l-.043.692a.116.116 0 0 1-.115.108m-46.248-.921a.115.115 0 0 1-.115-.112l-.023-.691a.115.115 0 0 1 .112-.119c.062-.005.117.048.119.111l.022.692a.115.115 0 0 1-.111.119zm46.364-1.384h-.004a.115.115 0 0 1-.111-.119l.02-.691c.001-.064.062-.111.118-.113a.115.115 0 0 1 .113.118l-.021.693a.115.115 0 0 1-.115.112m-46.438-.922a.115.115 0 0 1-.115-.112l-.023-.692a.115.115 0 0 1 .112-.119c.061.003.117.048.119.112l.022.692a.116.116 0 0 1-.111.119zm46.477-1.386a.116.116 0 0 1-.116-.115q0-.345-.004-.691a.115.115 0 0 1 .113-.117.12.12 0 0 1 .117.114q.005.348.005.693a.115.115 0 0 1-.115.116m-46.552-.921a.115.115 0 0 1-.115-.112l-.022-.692a.116.116 0 0 1 .112-.119c.054-.001.117.048.118.112l.023.692a.115.115 0 0 1-.112.119zm46.503-1.386a.116.116 0 0 1-.115-.111l-.033-.689a.115.115 0 0 1 .109-.122.114.114 0 0 1 .121.109q.02.346.034.693a.116.116 0 0 1-.111.12zm-46.577-.921a.115.115 0 0 1-.115-.111l-.022-.692a.115.115 0 0 1 .111-.119c.055-.007.117.048.119.112l.023.691a.115.115 0 0 1-.112.119zm46.429-1.382a.115.115 0 0 1-.115-.105q-.03-.344-.066-.688a.114.114 0 0 1 .103-.126.114.114 0 0 1 .126.102q.037.346.067.691a.114.114 0 0 1-.105.125zm-46.503-.924a.116.116 0 0 1-.115-.112l-.022-.692a.116.116 0 0 1 .111-.119c.055-.001.117.048.119.112l.022.692a.114.114 0 0 1-.111.119zm45.647-.692h-.692a.115.115 0 0 1-.115-.115c0-.064.051-.116.115-.116h.692c.064 0 .116.052.116.116a.116.116 0 0 1-.116.115m-2.307 0h-.693a.116.116 0 0 1 0-.231h.693a.116.116 0 0 1 0 .231m-2.308 0h-.692a.116.116 0 0 1-.116-.115c0-.064.052-.116.116-.116h.692c.064 0 .115.052.115.116a.115.115 0 0 1-.115.115m-2.308 0h-.692a.116.116 0 0 1-.116-.115c0-.064.052-.116.116-.116h.692c.064 0 .116.052.116.116a.116.116 0 0 1-.116.115m-2.308 0h-.692a.115.115 0 0 1-.115-.115c0-.064.051-.116.115-.116h.692c.064 0 .116.052.116.116a.116.116 0 0 1-.116.115m-2.307 0h-.693a.116.116 0 0 1 0-.231h.693a.116.116 0 0 1 0 .231m-2.308 0h-.692a.116.116 0 0 1-.116-.115c0-.064.052-.116.116-.116h.692c.064 0 .115.052.115.116a.115.115 0 0 1-.115.115m-2.308 0h-.692a.116.116 0 0 1-.116-.115c0-.064.052-.116.116-.116h.692c.064 0 .116.052.116.116a.116.116 0 0 1-.116.115m-2.308 0h-.692a.115.115 0 0 1-.115-.115c0-.064.051-.116.115-.116h.692c.064 0 .116.052.116.116a.116.116 0 0 1-.116.115m-2.307 0h-.693a.116.116 0 0 1 0-.231h.693a.116.116 0 0 1 0 .231m-2.308 0h-.692a.116.116 0 0 1-.116-.115c0-.064.052-.116.116-.116h.692c.064 0 .115.052.115.116a.115.115 0 0 1-.115.115m-2.308 0h-.692a.116.116 0 0 1-.116-.115c0-.064.052-.116.116-.116h.692c.064 0 .116.052.116.116a.116.116 0 0 1-.116.115m-2.308 0h-.692a.115.115 0 0 1-.115-.115c0-.064.051-.116.115-.116h.692c.064 0 .116.052.116.116a.116.116 0 0 1-.116.115m-2.307 0h-.693a.115.115 0 0 1-.115-.115c0-.064.051-.116.115-.116h.693a.116.116 0 0 1 0 .231m-2.308 0h-.692a.116.116 0 0 1-.116-.115c0-.064.052-.116.116-.116h.692c.064 0 .115.052.115.116a.115.115 0 0 1-.115.115m-2.308 0h-.692a.116.116 0 0 1-.116-.115c0-.064.052-.116.116-.116h.692c.064 0 .115.052.115.116a.115.115 0 0 1-.115.115m-2.308 0h-.692a.115.115 0 0 1-.115-.115c0-.064.051-.116.115-.116h.692c.064 0 .116.052.116.116a.116.116 0 0 1-.116.115m-2.308 0h-.692a.115.115 0 0 1-.115-.115c0-.064.051-.116.115-.116h.692c.064 0 .116.052.116.116a.116.116 0 0 1-.116.115m-2.307 0h-.693a.116.116 0 0 1 0-.231h.693c.064 0 .115.052.115.116a.115.115 0 0 1-.115.115m-2.308 0h-.692a.116.116 0 0 1-.116-.115c0-.064.052-.116.116-.116h.692c.064 0 .115.052.115.116a.115.115 0 0 1-.115.115",
    fill: "url(#w)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m173.607 183.01.117-1.246a.96.96 0 0 1 .726-.559c1.205-.191 4.192-.529 5.631.547l.215 1.447z",
    fill: "url(#x)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M177.371 181.812a1.7 1.7 0 0 1-.834 0 .755.755 0 0 1-.574-.73v-3.899h1.984v3.896a.755.755 0 0 1-.576.733",
    fill: "url(#y)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m192.828 183.01.116-1.246a.96.96 0 0 1 .727-.559c1.204-.191 4.192-.529 5.631.547l.214 1.447z",
    fill: "url(#z)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M196.592 181.812a1.7 1.7 0 0 1-.834-.001.75.75 0 0 1-.574-.729v-4.311h1.984v4.308a.755.755 0 0 1-.576.733",
    fill: "url(#A)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m175.762 178.138 21.342-.707a1.03 1.03 0 0 0 .983-.844c.116-.668.22-1.669.066-2.705-.175-1.18-1.189-2.055-2.386-2.084-3.982-.095-14.117-.092-19.703 2.118a1.95 1.95 0 0 0-1.179 1.353c-.143.587-.237 1.37-.051 2.168a.92.92 0 0 0 .928.701",
    fill: "url(#B)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M175.391 177.166a.23.23 0 0 1-.229-.208c-.004-.035-.084-.861.132-1.658a1.92 1.92 0 0 1 1.305-1.327c1.195-.35 3.48-.947 5.352-.999a.23.23 0 1 1 .013.461c-1.82.051-4.061.637-5.235.981-.481.141-.86.526-.99 1.005-.193.715-.119 1.483-.118 1.491a.23.23 0 0 1-.206.253z",
    fill: "url(#C)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M163.706 182.525c6.894-.088 36.721-.402 45.385.644.746.09 1.355.636 1.517 1.366.511 2.314 1.541 7.691 1.419 13.021a1.54 1.54 0 0 1-1.264 1.472l-19.777 3.742h-7.025l-21.073-4.189a1.65 1.65 0 0 1-1.329-1.53c-.137-2.681-.351-8.972.374-13.022a1.824 1.824 0 0 1 1.773-1.504",
    fill: "url(#D)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m184.129 201.18-.023-.002-.679-.135a.116.116 0 0 1-.091-.136.115.115 0 0 1 .136-.09l.673.133.016-.001h.692c.064 0 .115.052.115.116a.115.115 0 0 1-.115.115h-.692l-.016-.001zm5.339 0h-.692a.114.114 0 0 1-.115-.115c0-.064.051-.116.115-.116h.692a.115.115 0 1 1 0 .231m-2.307 0h-.693a.115.115 0 0 1-.115-.115c0-.064.052-.116.115-.116h.693c.063 0 .115.052.115.116a.115.115 0 0 1-.115.115m3.918-.048a.115.115 0 0 1-.113-.094.114.114 0 0 1 .092-.134l.68-.129a.115.115 0 1 1 .043.227l-.68.128zm-9.214-.402-.022-.002-.679-.135a.115.115 0 1 1 .045-.226l.679.135a.115.115 0 0 1 .09.136.115.115 0 0 1-.113.092m11.482-.027a.114.114 0 0 1-.113-.094.114.114 0 0 1 .092-.134l.68-.129a.116.116 0 0 1 .043.227l-.681.128q-.01.003-.021.002m-13.745-.423-.023-.002-.679-.135a.115.115 0 0 1-.09-.136.114.114 0 0 1 .135-.09l.679.135a.115.115 0 0 1-.022.228m16.012-.006a.115.115 0 0 1-.113-.094.114.114 0 0 1 .092-.134l.68-.129a.116.116 0 0 1 .135.092.115.115 0 0 1-.092.135l-.68.128zm2.268-.429a.114.114 0 0 1-.113-.094.114.114 0 0 1 .092-.134l.68-.129a.116.116 0 0 1 .135.092.117.117 0 0 1-.092.135l-.681.128q-.01.002-.021.002m-20.544-.014-.022-.003-.679-.135a.115.115 0 0 1-.091-.135.115.115 0 0 1 .136-.091l.679.135a.115.115 0 0 1 .09.136.116.116 0 0 1-.113.093m22.811-.415a.115.115 0 0 1-.113-.094.114.114 0 0 1 .092-.134l.68-.129a.116.116 0 0 1 .135.092.115.115 0 0 1-.092.135l-.68.128q-.01.003-.022.002m-25.074-.036-.023-.002-.679-.135a.114.114 0 0 1-.09-.135.114.114 0 0 1 .135-.091l.679.135a.115.115 0 0 1 .091.136.115.115 0 0 1-.113.092m27.342-.393a.114.114 0 0 1-.113-.094.114.114 0 0 1 .092-.134l.68-.129a.116.116 0 0 1 .135.092.116.116 0 0 1-.092.135l-.68.128zm-29.606-.056-.022-.003-.679-.135a.114.114 0 0 1-.091-.135.116.116 0 0 1 .136-.091l.679.135a.115.115 0 0 1 .09.136.116.116 0 0 1-.113.093m31.873-.372a.116.116 0 0 1-.113-.094.116.116 0 0 1 .092-.135l.681-.129a.114.114 0 0 1 .134.092.115.115 0 0 1-.092.135l-.68.129zm-34.136-.078-.023-.003-.679-.134a.115.115 0 0 1-.09-.136.114.114 0 0 1 .135-.091l.679.135a.115.115 0 0 1-.022.229m36.404-.352a.115.115 0 0 1-.113-.094.114.114 0 0 1 .092-.134l.68-.129a.117.117 0 0 1 .135.092.116.116 0 0 1-.092.135l-.68.128zm-38.667-.098-.023-.002-.679-.135a.116.116 0 0 1 .045-.227l.679.135a.115.115 0 0 1-.022.229m40.935-.33a.12.12 0 0 1-.114-.094.116.116 0 0 1 .092-.135l.681-.129a.114.114 0 0 1 .134.092.115.115 0 0 1-.092.135l-.68.128zm-43.199-.12-.023-.002-.679-.135a.115.115 0 0 1-.09-.136.115.115 0 0 1 .135-.091l.679.135a.115.115 0 0 1-.022.229m-2.263-.45-.023-.002-.587-.117-.013-.274a.115.115 0 0 1 .109-.121c.063-.013.118.046.121.11l.005.094.41.081a.115.115 0 0 1-.022.229m46.573-.821a.116.116 0 0 1-.116-.114 52 52 0 0 0-.014-.69.115.115 0 0 1 .112-.119c.06.002.117.048.118.112q.01.346.015.694a.115.115 0 0 1-.114.117zm-47.148-1.077a.116.116 0 0 1-.115-.111l-.021-.693a.114.114 0 0 1 .112-.118c.063.005.117.048.119.112l.021.691a.115.115 0 0 1-.112.119zm47.057-1.228a.115.115 0 0 1-.115-.108 50 50 0 0 0-.05-.69.116.116 0 0 1 .106-.124.115.115 0 0 1 .124.106q.027.345.05.693a.117.117 0 0 1-.108.123zm-47.109-1.079a.116.116 0 0 1-.116-.114l-.005-.693a.115.115 0 1 1 .23-.001q.002.35.006.691a.115.115 0 0 1-.114.117zm46.909-1.222a.115.115 0 0 1-.115-.103l-.078-.686a.115.115 0 1 1 .229-.028q.04.34.079.69a.116.116 0 0 1-.103.127zm-46.906-1.086h-.002a.115.115 0 0 1-.114-.117l.014-.694c.002-.063.055-.11.119-.112a.114.114 0 0 1 .112.118l-.014.691a.115.115 0 0 1-.115.114m46.613-1.203a.116.116 0 0 1-.114-.099q-.052-.35-.104-.684a.116.116 0 0 1 .096-.132.116.116 0 0 1 .131.096q.054.335.105.687a.116.116 0 0 1-.097.131zm-46.538-1.104h-.006a.115.115 0 0 1-.109-.122q.017-.348.041-.692a.114.114 0 0 1 .122-.108.115.115 0 0 1 .108.123q-.023.342-.041.69a.115.115 0 0 1-.115.109m46.162-1.175a.116.116 0 0 1-.114-.094 46 46 0 0 0-.128-.679.116.116 0 0 1 .091-.136.117.117 0 0 1 .136.091q.063.324.128.682a.116.116 0 0 1-.092.135zm-45.981-1.126-.013-.001a.115.115 0 0 1-.102-.127q.039-.353.084-.69c.009-.063.067-.111.13-.099a.115.115 0 0 1 .099.13q-.045.334-.084.684a.115.115 0 0 1-.114.103m45.425-1.044h-.013q-.321-.038-.686-.074a.115.115 0 0 1-.104-.126c.006-.064.061-.106.126-.104q.369.037.691.074a.116.116 0 0 1-.014.23m-2.298-.207-.008-.001-.69-.046a.115.115 0 1 1 .015-.231q.358.023.691.047a.116.116 0 0 1-.008.231m-2.304-.138h-.006l-.691-.034a.115.115 0 1 1 .011-.23l.692.033a.115.115 0 0 1-.006.231m-2.305-.101h-.005l-.691-.025a.116.116 0 0 1-.112-.119c.002-.064.059-.111.119-.112l.693.025a.116.116 0 0 1 .111.12.116.116 0 0 1-.115.111m-2.307-.077h-.004l-.691-.02a.115.115 0 0 1-.113-.118c.002-.064.046-.111.119-.112l.692.019a.116.116 0 0 1 .112.119.115.115 0 0 1-.115.112m-2.307-.06h-.003l-.692-.015a.115.115 0 0 1 .003-.231h.002l.692.016a.115.115 0 0 1-.002.23m-2.308-.046h-.002l-.692-.012a.115.115 0 0 1 .002-.231h.002l.692.012a.116.116 0 0 1 .114.118.116.116 0 0 1-.116.113m-30.698 0a.116.116 0 0 1-.002-.231l.693-.008h.001c.063 0 .115.05.116.114a.116.116 0 0 1-.114.116zm2.308-.027a.115.115 0 0 1-.115-.114.114.114 0 0 1 .114-.116l.693-.007h.001c.063 0 .115.05.116.114a.115.115 0 0 1-.115.116l-.692.007zm26.082-.009h-.001l-.692-.009a.115.115 0 0 1 .001-.231h.002l.692.009a.115.115 0 0 1-.002.231m-23.773-.013a.115.115 0 0 1-.115-.114.115.115 0 0 1 .114-.117l.693-.006h.001c.063 0 .115.051.115.115a.115.115 0 0 1-.114.116zm21.466-.015h-.001l-.692-.006a.117.117 0 0 1-.115-.116.116.116 0 0 1 .116-.115h.001l.692.007c.064 0 .115.052.114.116a.115.115 0 0 1-.115.114m-19.157-.004a.115.115 0 1 1-.001-.23l.692-.005h.001c.063 0 .115.051.116.114a.115.115 0 0 1-.115.116zm16.849-.015-.692-.005a.115.115 0 1 1 .001-.23l.693.004a.115.115 0 0 1 .114.116.115.115 0 0 1-.115.115m-14.541 0a.115.115 0 0 1-.115-.115c0-.064.051-.115.115-.116l.692-.004h.001a.116.116 0 0 1 0 .231zm2.309-.012a.116.116 0 0 1-.116-.115c0-.063.052-.115.115-.115l.693-.003a.115.115 0 1 1 .001.231zm9.924-.002-.693-.002a.114.114 0 0 1-.114-.116c0-.064.051-.115.115-.115l.693.003a.115.115 0 1 1-.001.23m-7.616-.006a.115.115 0 1 1 0-.23l.692-.002c.06-.005.116.052.116.115a.115.115 0 0 1-.115.116zm5.308-.001-.692-.001a.116.116 0 0 1-.116-.116.117.117 0 0 1 .116-.115l.692.001c.064 0 .116.052.116.116a.117.117 0 0 1-.116.115m-3-.002a.116.116 0 0 1 0-.231h.69a.115.115 0 1 1 .002.231z",
    fill: "url(#E)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M190.326 205.719h-6.155a1.59 1.59 0 0 1-1.581-1.397l-.711-5.923a1.587 1.587 0 0 1 1.581-1.773h7.394c.935 0 1.669.798 1.586 1.725l-.528 5.923a1.59 1.59 0 0 1-1.586 1.445",
    fill: "url(#F)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M189.569 204.63h-4.684a1.21 1.21 0 0 1-1.204-1.064l-.541-4.507a1.208 1.208 0 0 1 1.203-1.35h5.628c.711 0 1.27.607 1.207 1.313l-.402 4.508a1.21 1.21 0 0 1-1.207 1.1",
    fill: "url(#G)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m119.029 69.315.005-.158a.44.44 0 0 0-.145-.342c-.569-.51-2.699-2.263-5.71-2.808a.38.38 0 0 0-.382.16c.251.03.587.093 1.04.213 1.489.39 3.652 1.43 5.192 2.935",
    fill: "url(#H)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M113.838 66.38a8 8 0 0 0-1.04-.214.38.38 0 0 0-.01.418q.073.118.183.258c.471.59 4.279 4.496 4.279 4.496s1.209.148 1.579-.066c.119-.07.179-1.324.201-1.957-1.54-1.504-3.703-2.545-5.192-2.936",
    fill: "url(#I)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M118.885 73.373v-2.327a.45.45 0 0 0-.313-.435c-.289-.092-.733-.18-1.137-.028a.66.66 0 0 0-.416.566l-.173 2.173z",
    fill: "url(#J)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M109.657 71.313a.47.47 0 0 0-.15-.226c-.489.096-1.506.365-3.59 1.101-2.416.853-3.123 1.598-3.327 1.997 1.035.303 3.388.766 6.763.107l.667-.313s-.047-1.626-.363-2.666",
    fill: "url(#K)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M105.917 72.188c2.084-.736 3.101-1.005 3.59-1.101a.47.47 0 0 0-.399-.1c-1.2.25-4.826 1.103-6.721 2.639a.304.304 0 0 0 .099.527l.104.031c.204-.398.911-1.143 3.327-1.996",
    fill: "url(#L)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m111.269 75.385-1.42-1.702a.53.53 0 0 0-.568-.164 1.94 1.94 0 0 0-.822.547.48.48 0 0 0-.071.546l1.033 2.003z",
    fill: "url(#M)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M116.536 72.563s1.733-.333 2.694 0c0 0 1.268 7.606 1.05 10.052l-3.744.76s-.107-8.569 0-10.812",
    fill: "url(#N)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M131.903 85.89s-12.244.687-17.213.344a1.38 1.38 0 0 1-1.137-.758c-1.065-2.132-4.259-8.53-4.539-9.14 0 0 1.297-1.085 2.255-1.234 0 0 4.535 5.044 4.724 7.618 0 0 10.502-3.02 11.539-2.991s4.218 1.447 4.218 1.447z",
    fill: "url(#O)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M148.223 76.346s-.45-.934-.06-1.427c.39-.492 1.794-2.018 1.794-2.018l.164-1.054.577 1.717-1.239 2.59s-.725.785-1.236.192",
    fill: "url(#P)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M151.369 80.692a19.6 19.6 0 0 0-1.91-4.537l-1.236.192.61 4.286c.466.141 1.74.463 2.536.059",
    fill: "url(#Q)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M152.168 84.865a25.3 25.3 0 0 0-.8-4.174c-.796.405-2.069.083-2.536-.058l.175 1.23-.468-1.657a9.62 9.62 0 0 0-3.454-5.055l-1.163-.88c-1.144-.865-2.972-.567-4.138.267-2.59 1.851-6.435 4.955-7.747 6.022a.97.97 0 0 1-1.002.134l-.219-.097a.293.293 0 0 0-.41.3l.557 5.096 8.898-.103c1.066 0 4.157-.11 4.648-1.057l.823-2.02c1.928 1.64 4.401 2.767 5.726 3.095.611.152 1.183-.382 1.11-1.043",
    fill: "url(#R)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m145.921 71.537-2.735 2.657a.487.487 0 0 0-.037.661c.844 1.005 1.568 1.532 2.17 1.572a.7.7 0 0 0 .634-.334l1.454-2.292z",
    fill: "url(#S)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m151.441 84.63 2.353-.916 2.736 2.176-4.898.018z",
    fill: "url(#T)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M150.505 70.922s-.373 2.624-1.381 3.431c-1.008.808-2.972.2-3.636-1.779l1.322-3.383z",
    fill: "url(#U)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M146.661 71.38a.13.13 0 0 0 .169-.103c.036-.243.127-.722.311-1.049 0 0-.096-.344.87.176.967.52 2.418 1.284 3.273.83.833-.444 1.677-2.677-.525-2.263a.13.13 0 0 1-.154-.136c.027-.367-.01-1.211-.865-1.482-.8-.254-1.238.107-1.418.325a.13.13 0 0 1-.202-.003c-.24-.313-.891-.979-1.849-.556-.789.347-.912.833-.899 1.136a.13.13 0 0 1-.184.124c-.242-.112-.631-.17-1.003.297-.515.645.221 1.205.442 1.351a.13.13 0 0 1 .059.108c.002.335.054 1.798.787 2.623a.13.13 0 0 0 .218-.037l.565-1.346a.13.13 0 0 1 .16-.073z",
    fill: "url(#V)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M146.672 71.654s-.345-1.405-.868-.949c-.524.456.136 1.46.736 1.651z",
    fill: "url(#W)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M142.736 77.579s.105-3.25-1.229-3.314c-1.658-.082-4.322 1.12-2.736 5.882.876 2.63 2.197 4.582 5.822 5.41a5.36 5.36 0 0 1 1.227-2.787c-1.477-1.04-2.728-2.662-3.084-5.191",
    fill: "url(#X)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M145.655 82.78a.13.13 0 0 1-.075-.024c-1.701-1.198-2.645-2.838-2.972-5.159l-.001-.022c.028-.869-.116-3.133-1.106-3.181a3.2 3.2 0 0 0-1.413.254.13.13 0 1 1-.103-.238 3.5 3.5 0 0 1 1.529-.275c1.418.069 1.36 3.186 1.353 3.436.317 2.24 1.227 3.82 2.863 4.972a.13.13 0 0 1-.075.237",
    fill: "url(#Y)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M143.439 85.36a.1.1 0 0 1-.043-.008c-3.007-1.038-4.059-3.096-4.748-5.165-.156-.469-.277-.92-.358-1.342a.13.13 0 0 1 .102-.152.13.13 0 0 1 .153.103c.079.41.197.851.349 1.309.668 2.006 1.687 4 4.587 5.002a.13.13 0 0 1 .081.165.13.13 0 0 1-.123.087",
    fill: "url(#Z)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m152.106 85.89-.005-1.26s-3.532.078-6.282-1.86a5.36 5.36 0 0 0-1.227 2.787c1.834.418 4.258.549 7.514.333",
    fill: "url(#aa)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M147.577 86.33h.026l11.235-.012a.5.5 0 0 0 .502-.503.5.5 0 0 0-.503-.502l-11.235.012a.502.502 0 0 0-.025 1.005",
    fill: "url(#ab)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M168.938 76.129h-9.357c-.69 0-1.318.398-1.613 1.023l-4.325 9.172h11.627c.445 0 .845-.272 1.008-.686l3.354-8.487a.747.747 0 0 0-.694-1.022",
    fill: "url(#ac)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M162.346 80.832c-.203.63-.053 1.241.335 1.366.387.125.866-.285 1.069-.915s.053-1.241-.335-1.366c-.387-.125-.866.285-1.069.915m73.277 29.125-19.136 11.306a.424.424 0 0 1-.618-.499l6.85-20.615a1.95 1.95 0 0 0-1.623-2.554c-2.108-.244-4.43-.247-6.988.035-5.477.603-23.38 3.376-23.035 23.455.346 20.08 16.129 23.027 29.879 22.211s21.392-18.185 18.635-28.179a35 35 0 0 0-1.508-4.358 1.72 1.72 0 0 0-2.456-.802",
    fill: "#91B3FA"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M217.076 141.537c-7.077 0-12.656-1.35-16.584-4.012a15.7 15.7 0 0 1-5.323-6.102c-1.402-2.825-2.147-6.314-2.217-10.37-.136-7.87 2.714-13.73 8.469-17.418 3.401-2.178 7.738-3.571 12.893-4.138a33 33 0 0 1 3.566-.204c1.033 0 2.042.056 3.002.167.013.002.03.004.048.031.019.031.012.053.008.066l-6.85 20.616a2.303 2.303 0 0 0 2.184 3.029c.41 0 .815-.111 1.171-.322l18.981-11.214a33 33 0 0 1 1.354 3.95c1.428 5.179-.321 12.634-4.253 18.129-1.602 2.238-3.463 4.034-5.53 5.338-2.223 1.402-4.63 2.189-7.153 2.338a64 64 0 0 1-3.766.116",
    fill: "#fff"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M242.131 101.765c-2.462-4.37-6.175-7.962-11.722-9.605a1.655 1.655 0 0 0-2.042 1.062l-6.69 20.135c-.26.783.59 1.47 1.301 1.05l18.736-11.07a1.16 1.16 0 0 0 .417-1.572",
    fill: "#91B3FA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M227.53 100.673a.347.347 0 0 1-.326-.463c.752-2.089 1.684-4.64 2.173-5.974a1.53 1.53 0 0 1 1.923-.919c1.301.446 3.797 1.527 5.897 3.76a.346.346 0 0 1-.504.475c-1.998-2.125-4.377-3.155-5.617-3.58a.835.835 0 0 0-1.049.502 1295 1295 0 0 0-2.172 5.97.345.345 0 0 1-.325.229",
    fill: "url(#ad)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M226.359 104.032a.342.342 0 0 1-.34-.401c.009-.051.026-.145.368-1.124a.346.346 0 1 1 .653.228c-.291.835-.334.992-.34 1.02a.35.35 0 0 1-.341.277",
    fill: "url(#ae)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M196.362 112.61a.33.33 0 0 1-.226-.09l-4.462-4.226a2.07 2.07 0 0 0-1.431-.57h-15.186a.329.329 0 0 1 0-.658h15.186a2.73 2.73 0 0 1 1.883.75l4.462 4.227a.328.328 0 0 1-.226.567m-8.45-6.925h-12.855a.328.328 0 0 1 0-.657h12.855a.328.328 0 0 1 0 .657m-2.092-2.038h-10.763a.328.328 0 0 1 0-.657h10.763a.329.329 0 1 1 0 .657",
    fill: "#7D97F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "af",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 201,
    y: 99,
    width: 19,
    height: 22
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m214.23 120.656 5.448-20.718s-9.485-2.793-18.498 3.75z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#af)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.703 112.805a.346.346 0 0 1-.278-.551l16.349-22.28a.347.347 0 0 1 .558.41l-16.349 22.28a.35.35 0 0 1-.28.141",
    fill: "url(#ag)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.039 114.105a.347.347 0 0 1-.279-.551l16.35-22.28a.347.347 0 0 1 .558.41l-16.349 22.28a.35.35 0 0 1-.28.141",
    fill: "url(#ah)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.373 115.405a.347.347 0 0 1-.279-.551l16.35-22.28a.346.346 0 0 1 .558.41l-16.349 22.28a.35.35 0 0 1-.28.141",
    fill: "url(#ai)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.709 116.705a.345.345 0 0 1-.279-.551l16.35-22.28a.346.346 0 0 1 .558.41l-16.35 22.279a.34.34 0 0 1-.279.142",
    fill: "url(#aj)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.047 118.004a.346.346 0 0 1-.279-.551l16.35-22.28a.347.347 0 0 1 .558.41l-16.35 22.28a.35.35 0 0 1-.279.141",
    fill: "url(#ak)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.381 119.305a.346.346 0 0 1-.279-.551l16.35-22.28a.347.347 0 0 1 .558.41l-16.35 22.28a.35.35 0 0 1-.279.141",
    fill: "url(#al)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.717 120.605a.346.346 0 0 1-.279-.551l16.35-22.28a.346.346 0 0 1 .558.41l-16.35 22.28a.35.35 0 0 1-.279.141",
    fill: "url(#am)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "an",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 200,
    y: 122,
    width: 31,
    height: 21
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M215.61 122.405c.39.284 14.918 15.261 14.918 15.261s-11.888 10.106-29.913-.447z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#an)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.613 139.518a.346.346 0 0 1-.278-.551l16.349-22.28a.346.346 0 0 1 .558.41l-16.349 22.28a.35.35 0 0 1-.28.141",
    fill: "url(#ao)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.949 140.818a.346.346 0 0 1-.278-.551l16.349-22.28a.346.346 0 0 1 .558.41l-16.349 22.28a.35.35 0 0 1-.28.141",
    fill: "url(#ap)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.283 142.117a.345.345 0 0 1-.278-.55l16.349-22.28a.346.346 0 0 1 .558.409l-16.349 22.28a.34.34 0 0 1-.28.141",
    fill: "url(#aq)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.619 143.417a.347.347 0 0 1-.279-.551l16.35-22.28a.346.346 0 0 1 .558.41l-16.349 22.28a.35.35 0 0 1-.28.141",
    fill: "url(#ar)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.955 144.717a.347.347 0 0 1-.279-.551l16.35-22.28a.346.346 0 0 1 .558.41l-16.349 22.28a.35.35 0 0 1-.28.141",
    fill: "url(#as)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.291 146.018a.347.347 0 0 1-.279-.551l16.35-22.28a.346.346 0 0 1 .558.41l-16.349 22.28a.35.35 0 0 1-.28.141",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.541 149.613a.347.347 0 0 1-.279-.551l16.35-22.28a.346.346 0 0 1 .558.409l-16.349 22.28a.35.35 0 0 1-.28.142",
    fill: "url(#au)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.664 151.409a.347.347 0 0 1-.279-.551l16.35-22.279a.346.346 0 0 1 .558.409l-16.349 22.28a.35.35 0 0 1-.28.141",
    fill: "url(#av)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.627 147.318a.347.347 0 0 1-.279-.551l16.35-22.28a.346.346 0 0 1 .558.41l-16.35 22.28a.34.34 0 0 1-.279.141",
    fill: "url(#aw)"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M193.381 173.42c.019-.007 9.893-17.3 11.228-18.927.224-.274.571-.413.923-.371l2.756.328 3.238 7.005-5.394-3.142c.534 3.692-6.396 9.178-8.773 11.18a.546.546 0 0 0-.043.795l.949.993c-1.558 1.579-3.355 2.593-5.384 3.062z",
    fill: "url(#ax)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M197.716 170.745s.605.196.81.735a.615.615 0 0 1-.232.711c-.997.715-4.286 3.021-5.804 3.473a.172.172 0 0 1-.214-.203c.078-.352.329-1.056 1.141-2.087l-.073.147c-.092.187.111.381.292.278 1.015-.573 3.083-1.827 4.08-3.054",
    fill: "url(#ay)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M197.227 177.665c.016-.011 1.498-3.58 1.514-3.591 1.359-8.27 4.673-15.353 5.65-17.217.165-.314.477-.52.83-.551l2.765-.236 4.589 6.205-5.919-1.985c1.27 3.507-4.406 10.282-6.328 12.724a.546.546 0 0 0 .118.787l1.131.781c-1.206 1.861-2.761 3.218-4.653 4.088z",
    fill: "url(#az)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M200.932 174.168s.632.069.942.556a.616.616 0 0 1-.083.743c-.832.901-3.586 3.826-4.981 4.575a.17.17 0 0 1-.251-.155c.005-.361.109-1.101.695-2.275l-.041.159c-.053.201.185.35.342.214.878-.767 2.649-2.414 3.377-3.817",
    fill: "url(#aA)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M220.932 154.763s2.502 3.721 2.707 5.419-.692 2.284-3.31 2.501c-7.793.644-11.634-1.692-11.634-1.692-.533-3.398-.913-4.263-5.365-6.111 0 0 5.631.447 6.764.007s10.838-.124 10.838-.124",
    fill: "url(#aB)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M214.168 154.27s-2.914-2.774-4.348-4.611a3.9 3.9 0 0 1-.66-3.509c.655-2.206 1.818-4.491 1.925-4.846.162-.545 3.429-.523 3.429-.523s6.428 4.172 8.954 11.24l-2.837.883s-1.678-2.816-3.336-4.607c0 0 2.869 3.791 2.97 5.343z",
    fill: "url(#aC)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M210.689 138.258c.035.114.887 2.94.954 2.999.067.058 1.87.155 2.719-.425L212.629 137z",
    fill: "url(#aD)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M208.344 135.083s-.607 1.402.107 3.534c.713 2.131 1.878 2.317 2.616 1.79s1.696-1.469 1.815-3.4-3.701-3.698-4.538-1.924",
    fill: "url(#aE)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M211.441 136.882s-1.288-2.886-3.22-1.088l-.149.742s-1.84-.524-1.235-2.191c.604-1.667 2.803-2.798 4.771-1.717s2.636 2.353 2.53 3.871c-.105 1.517-1.243.998-1.243.998s-.219-1.116-.753-1.314-.523.646-.523.646z",
    fill: "url(#aF)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M211.884 136.916s-.67-1.479.269-1.533.558 1.426.37 1.966z",
    fill: "url(#aG)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m208.617 155.365 2.189-2.382 2.529.681s2.947.457 4.634 0l1.687-.457 3.812-1.186.599 1.692c.152.429-.001.906-.372 1.17-.33.235-.716.492-.963.6-.502.22-11.565.069-11.565.069z",
    fill: "url(#aH)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M212.419 133.697c-.526-.064-.738-.715-.38-1.106 1.156-1.263 3.337-2.664 6.445-.514 3.501 2.422 5.396 3.518 6.256 3.288.564-.151 1.056.408.789.928-.197.384-.599.786-1.341 1.152-5.723 2.824-8.681-3.372-11.769-3.748",
    fill: "url(#aI)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "m215.861 156.308-.023.001-10.069-.011a.451.451 0 1 1 .001-.901l10.069.011a.45.45 0 0 1 .022.9",
    fill: "url(#aJ)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M196.717 147.166h8.386c.619 0 1.182.357 1.445.917l3.877 8.22h-10.421a.97.97 0 0 1-.903-.614l-3.007-7.607a.67.67 0 0 1 .623-.916",
    fill: "url(#aK)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M202.626 151.381c.182.564.047 1.113-.3 1.225-.347.111-.776-.256-.958-.82-.182-.565-.047-1.113.3-1.225s.776.255.958.82M52.834 116.49a.58.58 0 0 1-.553-.415 23 23 0 0 1-.248-.913.577.577 0 1 1 1.12-.279c.072.291.151.583.235.867a.576.576 0 0 1-.554.74m-.782-3.959a.577.577 0 0 1-.573-.517 23 23 0 0 1-.121-1.963.577.577 0 0 1 .565-.588h.012c.313 0 .57.251.576.566.012.622.05 1.249.115 1.865a.577.577 0 0 1-.574.637m.037-5.026a.577.577 0 0 1-.574-.645c.077-.65.183-1.303.314-1.941a.577.577 0 0 1 1.13.232 22 22 0 0 0-.298 1.845.577.577 0 0 1-.572.509m1.143-4.893a.578.578 0 0 1-.544-.771c.22-.615.468-1.228.74-1.823a.578.578 0 0 1 1.05.479 22 22 0 0 0-.703 1.732.58.58 0 0 1-.543.383m2.209-4.515a.577.577 0 0 1-.486-.887c.351-.552.73-1.094 1.128-1.613a.578.578 0 0 1 .916.702 22 22 0 0 0-1.071 1.531.58.58 0 0 1-.487.267m3.16-3.91a.577.577 0 0 1-.405-.987 23 23 0 0 1 1.456-1.322.577.577 0 1 1 .739.886 22 22 0 0 0-1.385 1.257.57.57 0 0 1-.405.166m3.946-3.112a.577.577 0 0 1-.305-1.067 23 23 0 0 1 1.713-.967.577.577 0 1 1 .524 1.028c-.553.282-1.1.59-1.628.918a.57.57 0 0 1-.304.088M83.689 89.7a.6.6 0 0 1-.239-.052 22 22 0 0 0-1.733-.7.577.577 0 1 1 .385-1.087 23 23 0 0 1 1.825.736.577.577 0 0 1-.239 1.103m-16.607-.786a.577.577 0 0 1-.188-1.123 23 23 0 0 1 1.885-.56.578.578 0 0 1 .281 1.119c-.602.15-1.204.33-1.79.532a.6.6 0 0 1-.188.032m11.826-.764a.6.6 0 0 1-.116-.012 22 22 0 0 0-1.846-.294.577.577 0 0 1 .133-1.147c.65.076 1.303.18 1.943.31a.577.577 0 0 1-.115 1.143m-6.923-.328a.577.577 0 0 1-.06-1.151c.649-.07 1.31-.111 1.963-.125h.012a.577.577 0 0 1 .012 1.154c-.621.013-1.248.053-1.865.119zm15.229 3.882a.57.57 0 0 1-.33-.103q-.367-.256-.748-.498a.577.577 0 1 1 .62-.973q.4.254.787.524a.577.577 0 0 1-.33 1.05m9.376 14.884a.576.576 0 0 1-.57-.485 22 22 0 0 0-.16-.885.577.577 0 1 1 1.131-.229c.063.308.12.622.17.931a.577.577 0 0 1-.571.668M74.424 132.63q-.4 0-.8-.013a.577.577 0 0 1 .039-1.154c.617.021 1.234.017 1.84-.013a.578.578 0 0 1 .056 1.153c-.375.018-.757.027-1.135.027m-3.83-.324a1 1 0 0 1-.098-.008 23 23 0 0 1-1.893-.406.577.577 0 0 1 .289-1.117c.59.153 1.196.283 1.799.386a.576.576 0 0 1-.097 1.145m7.98-.062a.577.577 0 0 1-.106-1.144 22 22 0 0 0 1.79-.416.577.577 0 1 1 .31 1.111c-.621.173-1.256.32-1.886.439a1 1 0 0 1-.108.01m-12.735-1.303a.6.6 0 0 1-.22-.044 23 23 0 0 1-1.757-.812.577.577 0 0 1 .528-1.026 22 22 0 0 0 1.669.771.577.577 0 0 1-.22 1.111m17.462-.144a.577.577 0 0 1-.23-1.107 22 22 0 0 0 1.656-.799.576.576 0 1 1 .545 1.016c-.568.305-1.154.588-1.743.842a.6.6 0 0 1-.228.048m4.295-2.449a.578.578 0 0 1-.34-1.044c.494-.359.98-.743 1.442-1.142a.577.577 0 0 1 .753.874 24 24 0 0 1-1.517 1.202.6.6 0 0 1-.338.11m3.658-3.327a.576.576 0 0 1-.432-.959 22 22 0 0 0 1.158-1.429.577.577 0 0 1 .926.689 23 23 0 0 1-1.219 1.503.57.57 0 0 1-.433.196m2.846-4.046a.577.577 0 0 1-.505-.855c.295-.535.57-1.09.817-1.647a.577.577 0 0 1 1.055.468 23 23 0 0 1-.86 1.735.58.58 0 0 1-.507.299m1.89-4.573a.577.577 0 0 1-.555-.737 22 22 0 0 0 .433-1.786.578.578 0 0 1 1.132.225 23 23 0 0 1-.457 1.88.58.58 0 0 1-.554.418m.837-4.874-.036-.001a.577.577 0 0 1-.54-.611 22 22 0 0 0 .035-1.839.577.577 0 0 1 .564-.589.57.57 0 0 1 .59.564 24 24 0 0 1-.038 1.935.576.576 0 0 1-.575.541M61.49 128.554a.6.6 0 0 1-.331-.104q-.385-.271-.763-.56a.577.577 0 1 1 .702-.916c.238.182.482.361.724.532a.576.576 0 0 1-.332 1.048",
    fill: "#7D97F4"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M62.269 121.862a.27.27 0 0 0 .302.083l3.08-1.133a14.3 14.3 0 0 0 4.078 2.196l.751 3.193a.27.27 0 0 0 .236.206l3.916.397a.27.27 0 0 0 .272-.155l1.376-2.977a14.3 14.3 0 0 0 4.436-1.334l2.79 1.727a.27.27 0 0 0 .313-.02l3.05-2.489a.27.27 0 0 0 .082-.302l-1.132-3.08a14.3 14.3 0 0 0 2.196-4.078l3.193-.751a.27.27 0 0 0 .206-.236l.397-3.916a.27.27 0 0 0-.155-.272l-2.977-1.376a14.3 14.3 0 0 0-1.334-4.436l1.727-2.791a.27.27 0 0 0-.02-.312l-2.489-3.05a.27.27 0 0 0-.302-.083l-3.08 1.133a14.3 14.3 0 0 0-4.078-2.196l-.751-3.193a.27.27 0 0 0-.236-.206l-3.916-.397a.27.27 0 0 0-.272.155l-1.377 2.977a14.3 14.3 0 0 0-4.435 1.334l-2.79-1.727a.27.27 0 0 0-.313.02l-3.05 2.489a.27.27 0 0 0-.083.302l1.133 3.08a14.3 14.3 0 0 0-2.196 4.078l-3.193.751a.27.27 0 0 0-.206.236l-.397 3.916a.27.27 0 0 0 .155.272l2.977 1.376a14.3 14.3 0 0 0 1.334 4.436L59.76 118.5a.27.27 0 0 0 .02.312z",
    fill: "#91B3FA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M74.412 113.367a3.96 3.96 0 0 1-3.912-3.38 3.96 3.96 0 0 1 3.337-4.492 3.93 3.93 0 0 1 2.938.739 3.93 3.93 0 0 1 1.554 2.599 3.962 3.962 0 0 1-3.917 4.534m.009-6.991q-.225 0-.449.032a3.04 3.04 0 0 0-2.56 3.444 3.037 3.037 0 0 0 3.445 2.559 3.036 3.036 0 0 0 2.559-3.443 3 3 0 0 0-1.192-1.993 3 3 0 0 0-1.803-.599",
    fill: "#BDD0FB"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M74.492 119.082a10 10 0 0 1-1.314-.087 10 10 0 0 1-1.523-.329l-.02-.006-.057-.018-.112-.035a.23.23 0 0 1-.148-.291.23.23 0 0 1 .29-.148 9.3 9.3 0 0 0 1.932.404 9.27 9.27 0 0 0 8.215-3.489 9.2 9.2 0 0 0 1.989-5.75 9.2 9.2 0 0 0-2.089-5.841 9.2 9.2 0 0 0-6.247-3.362c-5.086-.514-9.64 3.203-10.155 8.287a9.24 9.24 0 0 0 .827 4.868.23.23 0 0 1-.11.307.23.23 0 0 1-.308-.111 9.7 9.7 0 0 1-.868-5.11c.54-5.338 5.325-9.24 10.66-8.7a9.66 9.66 0 0 1 6.559 3.529 9.65 9.65 0 0 1 2.141 7.132 9.67 9.67 0 0 1-3.528 6.558 9.65 9.65 0 0 1-6.134 2.192",
    fill: "#BDD0FB"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M37.45 126.122a.23.23 0 0 1-.22-.166 10 10 0 0 1-.15-.571.23.23 0 1 1 .45-.103q.064.274.142.545a.23.23 0 0 1-.221.295m-.342-1.742a.23.23 0 0 1-.23-.207 10 10 0 0 1-.049-1.228.24.24 0 0 1 .236-.226.23.23 0 0 1 .226.236 9 9 0 0 0 .047 1.171.23.23 0 0 1-.206.253zm.05-2.396-.032-.002a.23.23 0 0 1-.196-.261c.058-.405.142-.81.25-1.203a.23.23 0 1 1 .445.121 10 10 0 0 0-.238 1.148.23.23 0 0 1-.228.197m.63-2.311a.23.23 0 0 1-.213-.319c.156-.377.337-.75.538-1.105a.23.23 0 0 1 .315-.088c.11.063.15.204.087.315a9 9 0 0 0-.513 1.054.23.23 0 0 1-.213.143m1.18-2.087a.23.23 0 0 1-.185-.368c.244-.328.51-.645.791-.94a.23.23 0 0 1 .334.319 10 10 0 0 0-.754.896.23.23 0 0 1-.186.093m1.653-1.734a.231.231 0 0 1-.146-.41q.476-.39.995-.719a.23.23 0 0 1 .247.39 10 10 0 0 0-.95.686.23.23 0 0 1-.146.053m2.024-1.282a.23.23 0 0 1-.099-.439c.37-.174.753-.327 1.14-.454a.23.23 0 1 1 .145.438 9 9 0 0 0-1.088.433.2.2 0 0 1-.098.022m8.147-.071a.2.2 0 0 1-.094-.02 9 9 0 0 0-1.096-.414.23.23 0 1 1 .136-.441c.391.121.778.267 1.15.434a.23.23 0 0 1-.096.441m-5.872-.676a.23.23 0 0 1-.044-.457c.4-.078.809-.132 1.217-.161a.23.23 0 1 1 .032.461c-.39.027-.78.078-1.161.153a.2.2 0 0 1-.044.004m3.583-.029-.041-.003a9 9 0 0 0-1.012-.124l-.152-.01a.23.23 0 0 1-.219-.242.23.23 0 0 1 .243-.219l.161.01q.536.037 1.06.13a.231.231 0 0 1-.04.458m3.842 1.587a.24.24 0 0 1-.131-.041 9 9 0 0 0-.471-.308.23.23 0 1 1 .24-.394q.247.151.494.323a.23.23 0 0 1-.132.42m4.09 6.625a.23.23 0 0 1-.229-.199 9 9 0 0 0-.095-.554.23.23 0 1 1 .452-.092q.06.29.1.582a.23.23 0 0 1-.228.263m-9.508 11.11a.231.231 0 0 1-.003-.462 10 10 0 0 0 1.15-.084.23.23 0 1 1 .062.457 10 10 0 0 1-1.206.089zm-1.18-.056-.024-.001q-.602-.065-1.192-.201a.23.23 0 1 1 .104-.45c.374.087.756.151 1.137.192a.23.23 0 0 1-.024.46m3.516-.26a.23.23 0 0 1-.059-.454c.371-.097.74-.218 1.095-.36a.231.231 0 0 1 .17.429 10 10 0 0 1-1.148.378.2.2 0 0 1-.058.007m-5.812-.272a.2.2 0 0 1-.079-.014q-.569-.208-1.108-.483a.231.231 0 0 1 .21-.411c.34.174.696.329 1.056.46a.23.23 0 0 1-.079.448m8-.598a.232.232 0 0 1-.11-.434 9 9 0 0 0 .976-.612.23.23 0 1 1 .269.375q-.492.352-1.024.643a.23.23 0 0 1-.11.028m1.918-1.371a.23.23 0 0 1-.156-.401 10 10 0 0 0 .801-.828.23.23 0 1 1 .35.3c-.26.305-.543.597-.84.869a.23.23 0 0 1-.155.06m1.533-1.79a.23.23 0 0 1-.192-.359 9 9 0 0 0 .58-.996.231.231 0 1 1 .412.207c-.18.358-.384.71-.608 1.045a.23.23 0 0 1-.192.103m1.059-2.107a.23.23 0 0 1-.218-.308 10 10 0 0 0 .321-1.107.231.231 0 0 1 .45.101 10 10 0 0 1-.336 1.161.23.23 0 0 1-.217.153m.517-2.299-.023-.001a.23.23 0 0 1-.206-.253 10 10 0 0 0 .047-1.152.23.23 0 0 1 .226-.235.236.236 0 0 1 .235.226 10 10 0 0 1-.05 1.207.23.23 0 0 1-.229.208m-15.136 7.088a.23.23 0 0 1-.13-.04 10 10 0 0 1-.478-.345.23.23 0 1 1 .28-.366q.223.169.457.329a.23.23 0 0 1-.13.422",
    fill: "#7D97F4"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M41.538 128.47a.12.12 0 0 0 .131.036l1.335-.491a6.2 6.2 0 0 0 1.768.952l.325 1.383a.12.12 0 0 0 .102.09l1.697.172a.12.12 0 0 0 .118-.068l.597-1.29a6.2 6.2 0 0 0 1.922-.578l1.21.749a.12.12 0 0 0 .134-.009l1.322-1.079a.12.12 0 0 0 .036-.131l-.49-1.334a6.2 6.2 0 0 0 .95-1.768l1.384-.325a.12.12 0 0 0 .09-.102l.172-1.698a.115.115 0 0 0-.067-.117l-1.29-.597a6.2 6.2 0 0 0-.579-1.922l.75-1.209a.12.12 0 0 0-.01-.136l-1.078-1.322a.12.12 0 0 0-.131-.035l-1.335.491a6.2 6.2 0 0 0-1.767-.952l-.326-1.384a.12.12 0 0 0-.102-.089l-1.697-.172a.12.12 0 0 0-.118.067l-.596 1.29a6.2 6.2 0 0 0-1.923.578l-1.209-.748a.12.12 0 0 0-.135.008l-1.322 1.079a.12.12 0 0 0-.036.131l.49 1.335a6.2 6.2 0 0 0-.95 1.767l-1.384.326a.12.12 0 0 0-.09.102l-.172 1.697a.12.12 0 0 0 .067.118l1.29.596a6.2 6.2 0 0 0 .579 1.922l-.749 1.21a.12.12 0 0 0 .009.135z",
    fill: "#91B3FA"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M46.799 124.819c-.373 0-.734-.118-1.038-.344a1.747 1.747 0 0 1 .787-3.128 1.748 1.748 0 0 1 1.655 2.768 1.74 1.74 0 0 1-1.404.704m.004-3.03q-.093 0-.188.014a1.286 1.286 0 0 0-.579 2.301c.276.205.614.29.954.24s.638-.229.843-.504a1.286 1.286 0 0 0-1.03-2.051",
    fill: "#BDD0FB"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M46.831 127.395a4.4 4.4 0 0 1-1.31-.2l-.037-.012a.23.23 0 0 1-.148-.291.23.23 0 0 1 .29-.148q.396.128.81.169l.046.005a3.86 3.86 0 0 0 2.776-.838l.006-.005.02-.017a3.86 3.86 0 0 0 1.43-3.018c0-.892-.304-1.749-.875-2.449a3.85 3.85 0 0 0-2.62-1.409 3.87 3.87 0 0 0-2.848.855 3.86 3.86 0 0 0-1.429 3.013c0 .569.125 1.131.367 1.646a.23.23 0 1 1-.418.196 4.33 4.33 0 0 1-.388-2.283 4.32 4.32 0 0 1 1.576-2.93 4.32 4.32 0 0 1 3.187-.957 4.32 4.32 0 0 1 2.93 1.577 4.3 4.3 0 0 1 .957 3.186 4.354 4.354 0 0 1-4.322 3.91",
    fill: "#BDD0FB"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "m43.177 155.948-.653.232a.211.211 0 1 1-.141-.398l.653-.231a.21.21 0 0 1 .14.397m-2.126.839-.627.294a.214.214 0 0 1-.181-.386l.628-.293a.21.21 0 0 1 .282.103.21.21 0 0 1-.102.282m-2.037 1.04-.596.351a.216.216 0 0 1-.219-.371l.597-.351a.215.215 0 0 1 .218.371m-1.931 1.224-.562.405a.217.217 0 0 1-.254-.353v-.001l.563-.403a.216.216 0 1 1 .253.352m-1.814 1.393-.524.453a.22.22 0 0 1-.287-.333l.525-.451a.219.219 0 1 1 .286.331m-1.687 1.546-.484.495a.222.222 0 0 1-.317-.31l.485-.495a.22.22 0 0 1 .313-.002.22.22 0 0 1 .003.312m-1.553 1.681-.442.533a.224.224 0 1 1-.345-.286l.443-.532a.223.223 0 1 1 .344.285m-1.411 1.803-.398.566a.226.226 0 0 1-.37-.259v-.001l.4-.565a.226.226 0 0 1 .368.259m-1.267 1.908-.352.596a.228.228 0 0 1-.392-.232l.354-.596a.227.227 0 0 1 .39.232m-1.11 2.002-.305.622a.23.23 0 1 1-.413-.203l.306-.621a.23.23 0 1 1 .412.202m-.954 2.082-.256.643a.233.233 0 0 1-.431-.172l.257-.643a.232.232 0 0 1 .43.172m-.789 2.148-.205.662a.235.235 0 0 1-.448-.139l.207-.661a.234.234 0 1 1 .446.138m-.615 2.204-.152.676a.236.236 0 0 1-.461-.103v-.001l.154-.675a.236.236 0 0 1 .46.103m-.439 2.246-.097.686a.237.237 0 0 1-.269.202.24.24 0 0 1-.203-.269l.098-.686a.238.238 0 0 1 .47.067m-.25 2.273-.039.691a.24.24 0 1 1-.48-.027l.04-.691a.24.24 0 0 1 .479.027m-.059 2.286.022.688v.005a.242.242 0 1 1-.485.015l-.02-.695a.242.242 0 0 1 .483-.015zm.138 2.283.078.688a.244.244 0 0 1-.487.055l-.076-.688a.244.244 0 0 1 .485-.055m.321 2.265.132.679a.247.247 0 0 1-.484.095v-.001l-.131-.68a.246.246 0 0 1 .483-.093m.496 2.233.184.667a.248.248 0 1 1-.48.133v-.001l-.183-.668a.247.247 0 0 1 .174-.304.247.247 0 0 1 .305.173m.667 2.19.233.652a.25.25 0 0 1-.472.169v-.001l-.233-.652a.25.25 0 0 1 .471-.168m.825 2.135.28.633a.25.25 0 0 1-.129.333.25.25 0 0 1-.333-.129l-.279-.634a.252.252 0 0 1 .462-.203m.979 2.07.323.612a.254.254 0 0 1-.106.344.254.254 0 0 1-.345-.106l-.323-.613a.254.254 0 0 1 .107-.343.253.253 0 0 1 .343.106m1.117 1.998.365.589a.257.257 0 0 1-.437.271v-.001l-.364-.589a.257.257 0 0 1 .436-.27m1.254 1.917.403.563a.26.26 0 0 1-.42.302h-.001l-.403-.563a.259.259 0 0 1 .42-.302m1.379 1.829.44.535a.262.262 0 0 1-.404.332l-.44-.536a.261.261 0 0 1 .404-.331m1.496 1.735.474.505a.263.263 0 1 1-.384.36l-.473-.505a.26.26 0 0 1 .012-.371.26.26 0 0 1 .37.011m1.605 1.632.506.472a.265.265 0 0 1-.361.389v-.001l-.506-.473a.264.264 0 0 1 .361-.387m1.712 1.522.536.438a.267.267 0 1 1-.338.415v-.001l-.537-.438a.267.267 0 0 1 .338-.414m1.808 1.406.564.401a.27.27 0 1 1-.312.439l-.564-.402a.269.269 0 0 1 .312-.438m1.898 1.281.59.362a.272.272 0 0 1-.284.463l-.59-.363a.271.271 0 0 1 .284-.462m1.979 1.148.614.32a.274.274 0 0 1-.253.486l-.614-.321a.273.273 0 0 1 .253-.485m2.054 1.009.635.278a.276.276 0 0 1-.222.506v-.001l-.634-.279a.275.275 0 0 1 .221-.504m2.118.872.65.236a.278.278 0 0 1-.19.523v-.001l-.65-.237a.278.278 0 0 1 .19-.521m2.167.734.665.195a.28.28 0 1 1-.158.537l-.665-.196a.279.279 0 1 1 .158-.536m2.213.598.675.154a.282.282 0 0 1-.126.55l-.675-.155a.282.282 0 0 1 .126-.549m2.244.463.683.114a.284.284 0 0 1-.094.561l-.683-.115a.284.284 0 0 1 .094-.56m2.267.33.688.074a.286.286 0 0 1-.06.569h-.001l-.688-.075a.286.286 0 0 1 .06-.568m2.284.199.691.035a.287.287 0 0 1 .274.302.29.29 0 0 1-.303.274v-.001l-.691-.035a.288.288 0 0 1 .029-.575m2.289.069.692-.004a.29.29 0 1 1 .003.581l-.693.003a.29.29 0 0 1-.003-.58m2.292-.057.69-.042a.292.292 0 1 1 .036.584l-.692.04a.291.291 0 1 1-.035-.582m2.287-.18.687-.078a.292.292 0 1 1 .067.582l-.688.078a.293.293 0 0 1-.066-.582m2.27-.302.683-.115a.293.293 0 1 1 .097.579l-.683.114a.293.293 0 1 1-.097-.578m2.253-.422.675-.151a.294.294 0 0 1 .128.574l-.676.15a.293.293 0 1 1-.128-.573m2.23-.54.667-.186a.294.294 0 1 1 .158.567l-.667.186a.295.295 0 0 1-.158-.567m2.194-.658.656-.221a.295.295 0 0 1 .189.559l-.656.221a.295.295 0 0 1-.189-.559m2.158-.774.643-.256a.296.296 0 0 1 .218.549l-.643.256a.296.296 0 0 1-.218-.549m2.113-.888.63-.289a.296.296 0 0 1 .246.538l-.63.289a.296.296 0 0 1-.246-.538m2.067-.99.615-.319a.297.297 0 0 1 .273.526l-.615.319a.297.297 0 0 1-.272-.526m2.019-1.088.6-.345a.296.296 0 1 1 .296.514l-.6.345a.297.297 0 1 1-.296-.514m1.972-1.176.584-.372a.297.297 0 0 1 .32.502l-.585.371a.297.297 0 0 1-.319-.501m1.918-1.259.569-.395a.298.298 0 1 1 .34.489l-.57.395a.298.298 0 0 1-.339-.489m1.87-1.334.554-.416a.298.298 0 1 1 .358.477l-.554.415a.298.298 0 0 1-.358-.476m1.82-1.401.54-.434a.299.299 0 1 1 .374.465l-.54.434a.298.298 0 0 1-.374-.465m1.775-1.461.525-.451a.299.299 0 0 1 .39.454v.001l-.526.45a.299.299 0 0 1-.39-.454m1.731-1.513.513-.465a.3.3 0 0 1 .402.444l-.513.464a.3.3 0 0 1-.402-.443m1.692-1.561.501-.477a.3.3 0 1 1 .414.434l-.502.478a.3.3 0 0 1-.413-.435m1.653-1.6.492-.488a.301.301 0 0 1 .423.427l-.49.487a.3.3 0 1 1-.424-.426m1.623-1.633.482-.497a.302.302 0 0 1 .432.419l-.482.497a.3.3 0 0 1-.432-.419m1.593-1.663.474-.505a.302.302 0 0 1 .439.413l-.474.505a.302.302 0 0 1-.44-.413m1.57-1.686.468-.51a.302.302 0 1 1 .445.408l-.468.51a.302.302 0 1 1-.445-.408m1.553-1.704.463-.515a.302.302 0 0 1 .45.405l-.463.514a.3.3 0 0 1-.427.023.303.303 0 0 1-.023-.427m1.536-1.718.459-.519a.303.303 0 0 1 .454.402h-.001l-.459.518a.302.302 0 1 1-.453-.401m1.529-1.729.457-.52a.304.304 0 1 1 .455.401l-.457.52a.304.304 0 0 1-.455-.401m1.521-1.734.456-.521a.304.304 0 1 1 .457.401l-.456.52a.304.304 0 1 1-.457-.4m1.52-1.737.456-.52a.305.305 0 0 1 .458.401l-.457.521a.304.304 0 0 1-.457-.402m1.526-1.732.458-.519a.305.305 0 1 1 .457.404l-.459.518a.304.304 0 1 1-.456-.403m1.533-1.728.461-.516a.305.305 0 0 1 .455.407l-.462.516a.305.305 0 0 1-.454-.407m1.546-1.717.467-.512a.305.305 0 1 1 .452.412l-.467.511a.305.305 0 1 1-.452-.411m1.564-1.702.472-.507a.306.306 0 0 1 .448.418l-.473.506a.305.305 0 1 1-.447-.417m1.585-1.684.479-.5a.307.307 0 0 1 .443.425l-.48.499a.305.305 0 0 1-.433.009.305.305 0 0 1-.009-.433m1.611-1.659.488-.492a.307.307 0 0 1 .436.433h-.001l-.488.491a.307.307 0 1 1-.435-.432m1.641-1.632.498-.481a.308.308 0 1 1 .427.442l-.497.481a.308.308 0 0 1-.428-.442m1.675-1.596.509-.47a.309.309 0 0 1 .418.453l-.509.47a.308.308 0 0 1-.418-.453m1.715-1.556.521-.457a.308.308 0 1 1 .407.464l-.521.456a.308.308 0 1 1-.407-.463m1.755-1.511.533-.442a.31.31 0 0 1 .395.476h-.001l-.533.441a.308.308 0 1 1-.394-.475m1.801-1.459.547-.424a.309.309 0 1 1 .379.488v.001l-.547.424a.31.31 0 1 1-.379-.489m1.847-1.4.561-.406a.31.31 0 0 1 .432.07.31.31 0 0 1-.069.433l-.562.405a.31.31 0 1 1-.362-.502m1.9-1.334.577-.383a.31.31 0 1 1 .344.517l-.577.383a.31.31 0 1 1-.344-.517m1.948-1.257.592-.36a.31.31 0 0 1 .323.531l-.591.36a.31.31 0 0 1-.324-.531m1.999-1.18.605-.337a.31.31 0 1 1 .303.544l-.605.337a.31.31 0 0 1-.423-.121.31.31 0 0 1 .12-.423m2.041-1.101.617-.314a.313.313 0 0 1 .282.557l-.617.313a.312.312 0 1 1-.282-.556m2.083-1.022.629-.29a.313.313 0 0 1 .261.567v.001l-.629.289a.312.312 0 0 1-.261-.567m2.118-.942.639-.266a.312.312 0 1 1 .241.577l-.64.266a.312.312 0 0 1-.24-.577m2.154-.864.648-.242a.313.313 0 1 1 .219.587l-.648.242a.313.313 0 1 1-.219-.587m2.183-.782.657-.218a.314.314 0 1 1 .198.595l-.658.218a.314.314 0 0 1-.197-.595m2.21-.703.665-.194a.313.313 0 0 1 .389.213.313.313 0 0 1-.213.389v.001l-.665.194a.314.314 0 0 1-.176-.603m2.234-.623.671-.17a.315.315 0 0 1 .155.61l-.671.17a.314.314 0 0 1-.155-.61m2.253-.543.677-.146a.315.315 0 1 1 .133.616l-.676.146a.315.315 0 0 1-.134-.616m2.271-.462.682-.123a.315.315 0 0 1 .112.621l-.682.123a.315.315 0 1 1-.112-.621m2.289-.382.685-.099a.316.316 0 0 1 .091.625l-.686.099a.316.316 0 1 1-.09-.625m2.299-.304.688-.075a.317.317 0 1 1 .068.629l-.688.075a.317.317 0 1 1-.068-.629m2.306-.223.69-.051a.317.317 0 1 1 .047.632l-.691.051a.317.317 0 1 1-.046-.632m2.316-.143.692-.027a.317.317 0 0 1 .024.635l-.691.027a.318.318 0 0 1-.025-.635m2.318-.063.692-.003a.318.318 0 0 1 .003.636l-.692.003a.318.318 0 0 1-.003-.636m2.318.017.692.021a.319.319 0 1 1-.019.636l-.692-.021a.318.318 0 1 1 .019-.636m2.316.098.691.044a.32.32 0 0 1-.041.637l-.691-.045a.318.318 0 1 1 .041-.636m2.313.177.688.069a.32.32 0 0 1 .286.349.32.32 0 0 1-.349.286l-.689-.069a.32.32 0 1 1 .064-.635m2.304.258.686.092a.32.32 0 0 1-.085.634l-.687-.093a.32.32 0 0 1 .086-.633m2.293.339.683.117a.32.32 0 1 1-.109.631l-.682-.117a.32.32 0 0 1 .108-.631m2.283.419.678.141a.32.32 0 0 1-.13.628l-.678-.141a.32.32 0 1 1 .13-.628m2.264.502.672.165a.322.322 0 1 1-.153.624l-.672-.166a.32.32 0 1 1 .153-.623m2.244.582.666.19a.322.322 0 1 1-.176.618l-.666-.19a.321.321 0 1 1 .176-.618m2.223.664.659.214a.321.321 0 1 1-.199.612l-.659-.214a.322.322 0 0 1 .199-.612m2.198.745.65.238a.323.323 0 0 1-.222.606l-.65-.239a.323.323 0 1 1 .222-.605m2.166.826.641.263a.322.322 0 1 1-.245.598l-.641-.263a.322.322 0 1 1 .245-.598m2.135.91.63.287a.323.323 0 1 1-.268.588l-.63-.287a.322.322 0 1 1 .268-.588m2.098.988.619.312a.324.324 0 0 1-.291.578h-.001l-.618-.311a.324.324 0 0 1 .291-.579m2.059 1.072.606.335a.324.324 0 1 1-.314.568l-.606-.335a.324.324 0 1 1 .314-.568m2.016 1.15.592.359a.325.325 0 0 1-.337.556v-.001l-.592-.359a.324.324 0 1 1 .337-.555m1.967 1.229.579.379a.325.325 0 0 1-.356.545l-.001-.001-.579-.379a.325.325 0 0 1-.093-.45.324.324 0 0 1 .45-.094m1.925 1.285.57.394a.325.325 0 1 1-.37.536l-.57-.393a.326.326 0 0 1 .37-.537m1.896 1.325.563.401a.326.326 0 1 1-.378.532l-.564-.402a.327.327 0 1 1 .379-.531m1.877 1.346.561.405c.147.106.18.31.074.456a.326.326 0 0 1-.456.074h-.001l-.561-.406a.326.326 0 1 1 .383-.529m1.871 1.35.562.404a.328.328 0 0 1-.382.532l-.562-.405a.327.327 0 1 1 .382-.531m1.875 1.341.566.399a.327.327 0 1 1-.377.536l-.566-.399a.328.328 0 0 1 .377-.536m1.889 1.314.573.388a.328.328 0 1 1-.368.544l-.573-.389a.328.328 0 0 1 .368-.543m1.917 1.27.583.372a.33.33 0 0 1-.353.555l-.584-.372a.329.329 0 0 1 .354-.555m1.949 1.209.597.35a.328.328 0 1 1-.332.568l-.598-.35a.329.329 0 1 1 .333-.568m1.996 1.126.614.321a.33.33 0 1 1-.305.584h-.001l-.613-.321a.33.33 0 1 1 .305-.584m2.048 1.02.632.284a.33.33 0 0 1-.271.602l-.632-.284a.33.33 0 0 1 .271-.602m2.106.889.65.239a.331.331 0 0 1-.228.621l-.001-.001-.649-.239a.33.33 0 0 1 .228-.62m2.161.729.667.186a.331.331 0 0 1-.178.638l-.667-.187a.33.33 0 1 1 .178-.637m2.21.544.681.125a.332.332 0 0 1-.12.652l-.681-.125a.332.332 0 0 1 .12-.652m2.25.337.69.06a.331.331 0 1 1-.057.661l-.69-.059a.332.332 0 1 1 .057-.662m2.267.111.692-.016a.332.332 0 1 1 .015.665l-.692.015a.333.333 0 1 1-.015-.664m2.268-.137.686-.09a.333.333 0 0 1 .087.66h-.001l-.686.09a.333.333 0 0 1-.086-.66m2.24-.376.673-.16a.334.334 0 1 1 .154.649l-.673.16a.334.334 0 0 1-.154-.649m2.193-.604.654-.225a.333.333 0 1 1 .218.631l-.654.225a.333.333 0 1 1-.218-.631m2.126-.813.63-.286a.33.33 0 0 1 .442.166.333.333 0 0 1-.166.442l-.63.287a.336.336 0 0 1-.443-.167.333.333 0 0 1 .167-.442m2.041-1.007.602-.342a.335.335 0 0 1 .331.582l-.602.342a.334.334 0 0 1-.331-.582m1.947-1.183.57-.393a.334.334 0 0 1 .466.087.335.335 0 0 1-.086.466l-.57.392a.335.335 0 1 1-.38-.552m1.839-1.348.536-.438a.336.336 0 0 1 .425.52l-.536.438a.336.336 0 0 1-.425-.52m1.724-1.492.499-.481a.337.337 0 0 1 .466.485l-.499.48a.335.335 0 1 1-.466-.484m1.597-1.627.459-.519a.337.337 0 1 1 .504.447l-.459.518a.337.337 0 0 1-.504-.446m1.461-1.749.417-.553a.337.337 0 1 1 .538.405l-.416.553a.337.337 0 1 1-.539-.405m1.321-1.86.37-.585a.337.337 0 1 1 .571.361v.001l-.371.584a.337.337 0 1 1-.57-.361m1.166-1.96.321-.613a.338.338 0 1 1 .599.313v.001l-.321.613a.339.339 0 0 1-.599-.314m.996-2.049.268-.638a.34.34 0 0 1 .444-.181.34.34 0 0 1 .181.444h-.001l-.268.638a.339.339 0 0 1-.624-.263m.822-2.124.212-.659a.339.339 0 1 1 .645.208l-.212.659a.339.339 0 1 1-.645-.208m.633-2.19.159-.674a.34.34 0 0 1 .661.156l-.159.674a.34.34 0 0 1-.661-.156m.466-2.234.107-.684a.34.34 0 1 1 .672.106l-.108.684a.339.339 0 1 1-.671-.106m.298-2.263.057-.69a.341.341 0 0 1 .679.057l-.058.69a.34.34 0 0 1-.678-.057m.133-2.279.009-.692a.34.34 0 0 1 .346-.337.34.34 0 0 1 .336.346l-.009.692a.341.341 0 0 1-.682-.009m-.024-2.284-.038-.691a.342.342 0 1 1 .682-.037l.037.691a.341.341 0 0 1-.681.037m-.175-2.278-.082-.688a.342.342 0 0 1 .679-.081l.082.688a.342.342 0 0 1-.679.081m-.321-2.263-.125-.682a.343.343 0 0 1 .674-.123v.001l.124.681a.342.342 0 1 1-.673.123m-.459-2.242-.165-.672a.343.343 0 0 1 .666-.163l.164.672a.343.343 0 1 1-.665.163m-.589-2.209-.204-.662a.344.344 0 0 1 .656-.202v.001l.204.661a.345.345 0 0 1-.228.429.34.34 0 0 1-.428-.227m-.715-2.174-.24-.65a.343.343 0 1 1 .644-.238l.24.65a.343.343 0 1 1-.644.238m-.835-2.132-.275-.636a.343.343 0 1 1 .631-.273l.275.636a.344.344 0 1 1-.631.273m-.949-2.083-.309-.62a.344.344 0 1 1 .617-.307l.309.619a.344.344 0 0 1-.617.308m-1.059-2.03-.341-.603a.345.345 0 0 1 .601-.34l.341.603a.345.345 0 0 1-.601.34m-1.162-1.971-.372-.584a.345.345 0 1 1 .582-.372l.372.584a.346.346 0 0 1-.582.372m-1.268-1.907-.403-.564a.345.345 0 0 1 .081-.482.345.345 0 0 1 .482.08l.403.564a.346.346 0 0 1-.563.402m-1.366-1.834-.437-.537a.344.344 0 0 1 .532-.434l.439.536a.344.344 0 0 1-.533.436zm-1.477-1.746-.464-.514a.339.339 0 0 1 .502-.456l.466.512a.34.34 0 1 1-.503.459zm-1.565-1.679-.485-.494a.336.336 0 0 1 .478-.471l.487.493a.336.336 0 0 1-.48.473zm-1.627-1.622-.5-.479a.332.332 0 0 1 .458-.48l.502.478a.332.332 0 1 1-.459.482zm-1.676-1.574-.512-.465a.328.328 0 0 1 .44-.486l.514.464a.329.329 0 1 1-.441.488zm-1.725-1.541-.523-.453a.324.324 0 0 1 .423-.49l.525.451a.325.325 0 1 1-.424.493zm-1.749-1.495-.532-.443a.32.32 0 0 1-.041-.451.32.32 0 0 1 .449-.042l.534.441a.322.322 0 1 1-.409.495zm-1.778-1.462-.54-.433a.316.316 0 0 1 .394-.493l.542.431a.317.317 0 1 1-.395.496zm-1.806-1.429-.546-.425a.31.31 0 0 1 .379-.491l.55.42a.314.314 0 0 1-.38.498zm-1.823-1.405-.553-.417a.3.3 0 0 1 .358-.479l.556.411a.302.302 0 1 1-.359.487zm-1.848-1.377-.56-.409a.288.288 0 0 1 .338-.467l.563.403a.291.291 0 0 1-.339.474zm-1.866-1.349-.566-.399a.277.277 0 0 1 .318-.454l.569.394a.28.28 0 0 1-.319.461zm-1.89-1.32-.572-.391a.266.266 0 0 1 .299-.441l.575.386a.27.27 0 1 1-.3.447zm-1.908-1.291-.577-.382a.254.254 0 0 1 .279-.426l.581.376a.258.258 0 1 1-.281.434zm-1.927-1.258-.584-.373a.243.243 0 0 1 .259-.411l.588.366a.247.247 0 1 1-.261.419zm-1.949-1.23-.589-.363a.226.226 0 0 1 .233-.386l.595.354a.23.23 0 0 1 .08.316.23.23 0 0 1-.319.079m-1.97-1.195-.597-.35a.208.208 0 0 1 .208-.36l.602.342a.213.213 0 1 1-.213.368m-1.994-1.149-.605-.336a.19.19 0 0 1 .181-.333l.61.327c.095.05.131.169.08.263a.194.194 0 0 1-.263.08zm-2.024-1.097-.615-.319a.17.17 0 0 1 .153-.303l.621.307a.177.177 0 1 1-.156.317zm-2.058-1.034-.515-.242a.147.147 0 0 1 .122-.267l.52.231a.153.153 0 0 1 .078.202.154.154 0 0 1-.202.078zm-1.622-4.472-1.026 3.405-1.866-2.158z",
    fill: "#7D97F4"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m196.691 87.606 6.768 10.837a.9.9 0 0 0 1.268.268l10.625-7.204a.361.361 0 0 0-.14-.654z",
    fill: "#91B3FA"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m211.415 94.173-14.724-6.567 13.013 7.735-.244.957z",
    fill: "#7D97F4"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "m208.686 96.026 1.706 1.552-.687-2.237z",
    fill: "#7D97F4"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M80.064 216.52q.072 0 .145-.008a1.256 1.256 0 0 0 1.105-1.391l-7.884-68.61a1.257 1.257 0 0 0-2.496.287l7.884 68.61c.074.64.617 1.112 1.246 1.112",
    fill: "url(#aL)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M36.724 216.52c.575 0 1.094-.397 1.225-.982l15.383-68.61a1.256 1.256 0 1 0-2.451-.549l-15.383 68.609a1.257 1.257 0 0 0 1.226 1.532",
    fill: "url(#aM)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M62.703 216.52c.694 0 1.256-.563 1.256-1.256v-33.861a1.256 1.256 0 0 0-2.512 0v33.861c0 .693.563 1.256 1.256 1.256",
    fill: "url(#aN)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M87.84 138.978 83.424 194.6a2.223 2.223 0 0 1-2.27 2.046l-46.122-1.125a2.223 2.223 0 0 1-2.14-2.572l8.829-55.462a2.22 2.22 0 0 1 2.246-1.872l41.708.966a2.22 2.22 0 0 1 2.165 2.397",
    fill: "url(#aO)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "m83.98 138.111-38.677-.896a2.224 2.224 0 0 0-2.246 1.873l-8.332 52.335a2.222 2.222 0 0 0 2.141 2.571l42.842 1.045a2.223 2.223 0 0 0 2.27-2.046l4.166-52.484a2.22 2.22 0 0 0-2.164-2.398",
    fill: "#91B3FA"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "m63.107 143.464 19.493 1.088c.2.011.351.185.334.384l-.027.313a.355.355 0 0 1-.379.324l-19.466-1.4a.356.356 0 0 1 .045-.709",
    fill: "url(#aP)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "m62.593 145.418-.012.134a.354.354 0 0 0 .323.383l19.444 1.669a.355.355 0 0 0 .384-.323l.011-.133a.355.355 0 0 0-.323-.384l-19.443-1.669a.355.355 0 0 0-.384.323",
    fill: "url(#aQ)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "m68.346 147.667-.005.059a.355.355 0 0 0 .323.384l13.542 1.162a.355.355 0 0 0 .384-.323l.024-.275a.355.355 0 0 0-.33-.385l-13.56-.945a.354.354 0 0 0-.378.323",
    fill: "url(#aR)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M77.387 160.081a.35.35 0 0 1-.242-.098l-5.932-5.756-6.702 4.055a.347.347 0 0 1-.464-.099l-7.861-11.325-8.958 6.555a.347.347 0 0 1-.408-.56c1.02-.744 9.243-6.763 9.243-6.763a.35.35 0 0 1 .49.082l7.878 11.349 6.652-4.025a.346.346 0 0 1 .42.048l5.915 5.739 3.622-2.641a.346.346 0 1 1 .408.559l-3.857 2.814a.35.35 0 0 1-.204.066",
    fill: "url(#aS)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "m54.934 163.225-.02-.001a.23.23 0 0 1-.21-.25l.06-.69a.23.23 0 0 1 .251-.21c.127.012.22.124.21.251l-.061.689a.23.23 0 0 1-.23.211m.203-2.299-.02-.001a.23.23 0 0 1-.21-.25l.06-.69a.23.23 0 0 1 .46.041l-.06.689a.23.23 0 0 1-.23.211m.203-2.299-.02-.001a.23.23 0 0 1-.21-.25l.06-.69a.23.23 0 0 1 .46.041l-.06.689a.23.23 0 0 1-.23.211m.203-2.299-.02-.001a.23.23 0 0 1-.21-.25l.06-.689a.23.23 0 0 1 .25-.21.23.23 0 0 1 .21.25l-.06.69a.23.23 0 0 1-.23.21m.203-2.298-.02-.001a.23.23 0 0 1-.21-.251l.06-.689a.23.23 0 0 1 .46.04l-.06.69a.23.23 0 0 1-.23.211m.203-2.3h-.02a.23.23 0 0 1-.21-.251l.06-.689a.23.23 0 1 1 .46.04l-.06.69a.23.23 0 0 1-.23.21m.203-2.298-.02-.001a.23.23 0 0 1-.21-.25l.06-.69a.23.23 0 1 1 .46.041l-.06.689a.23.23 0 0 1-.23.211",
    fill: "url(#aT)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "m63.813 164.096-.02-.001a.23.23 0 0 1-.21-.251l.06-.689a.23.23 0 0 1 .251-.21c.127.012.22.124.21.25l-.061.69a.23.23 0 0 1-.23.211m.203-2.299-.02-.001a.23.23 0 0 1-.21-.25l.06-.69a.23.23 0 1 1 .46.041l-.06.689a.23.23 0 0 1-.23.211m.203-2.299-.02-.001a.23.23 0 0 1-.21-.25l.06-.69a.233.233 0 0 1 .25-.21.23.23 0 0 1 .21.251l-.06.689a.23.23 0 0 1-.23.211",
    fill: "url(#aU)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M70.52 164.968h-.013a.23.23 0 0 1-.218-.243l.04-.692a.23.23 0 0 1 .243-.217.23.23 0 0 1 .218.244l-.04.691a.23.23 0 0 1-.23.217m.132-2.304h-.014a.23.23 0 0 1-.217-.243l.04-.691a.231.231 0 1 1 .46.026l-.04.691a.23.23 0 0 1-.23.217m.131-2.303-.013-.001a.23.23 0 0 1-.218-.243l.04-.692a.23.23 0 1 1 .46.027l-.039.691a.23.23 0 0 1-.23.218m.132-2.305H70.9a.23.23 0 0 1-.217-.244l.04-.691a.231.231 0 0 1 .46.027l-.04.691a.23.23 0 0 1-.23.217m.131-2.304h-.013a.23.23 0 0 1-.217-.243l.039-.692a.23.23 0 0 1 .244-.217.23.23 0 0 1 .217.243l-.04.692a.23.23 0 0 1-.23.217",
    fill: "url(#aV)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "m76.967 165.681-.02-.001a.23.23 0 0 1-.21-.25l.061-.69a.23.23 0 0 1 .25-.21.23.23 0 0 1 .21.251l-.061.689a.23.23 0 0 1-.23.211m.203-2.299-.02-.001a.23.23 0 0 1-.21-.25l.061-.69a.23.23 0 1 1 .46.041l-.061.689a.23.23 0 0 1-.23.211m.203-2.299-.02-.001a.23.23 0 0 1-.21-.25l.061-.69a.23.23 0 0 1 .46.041l-.061.689a.23.23 0 0 1-.23.211",
    fill: "url(#aW)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "m45.249 164.901-.035-.002a.346.346 0 0 1-.31-.379l2.08-20.808a.346.346 0 0 1 .689.069l-2.08 20.808a.346.346 0 0 1-.344.312",
    fill: "url(#aX)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "m46.023 145.002 1.285-1.052 1.051 1.285.1-.991-1.052-1.285-1.284 1.051z",
    fill: "url(#aY)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "m81.025 167.044-.031-.001-37.06-3.272a.346.346 0 0 1 .062-.69l37.059 3.272a.346.346 0 0 1-.03.691",
    fill: "url(#aZ)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "m79.547 167.745 1.273-1.066-1.067-1.273.993.088 1.066 1.272-1.272 1.066z",
    fill: "url(#ba)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M50.092 216.226a.4.4 0 0 0-.01-.105c-.521-2.063-3.105-3.349-3.105-3.349l-1.023.081c-.589 1.818-.513 2.934-.419 3.431l.01.04c.845.076 2.583.125 4.547-.098",
    fill: "url(#bb)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M45.547 216.324a.44.44 0 0 0 .325.328c1.2.253 3.11.05 3.912-.055.177-.023.306-.187.309-.371-1.964.223-3.702.174-4.546.098",
    fill: "url(#bc)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "m60.468 149.718 6.743-2.447.52 1.088-6.482 2.443s-.901-.081-.78-1.084",
    fill: "url(#bd)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M67.21 147.27c-.198.602.52 1.089.52 1.089l1.223-.865a2.5 2.5 0 0 1-.13-.477z",
    fill: "url(#be)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M68.824 147.017c.023.144.064.306.13.477l.903-.64z",
    fill: "url(#bf)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M41.492 179.697c-.633.675-1.563 1.258-2.219 1.622.979 1.209 2.302 2.42 4.055 3.605l.502 1.126 1.606-1.926s-2.883-1.435-3.944-4.427",
    fill: "url(#bg)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "m45.543 211.328.434 2.087a.34.34 0 0 0 .291.281c.174.016.422.026.672-.01.223-.033.38-.261.34-.505l-.302-1.853z",
    fill: "url(#bh)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M54.526 216.304c-1.13-.032-1.716-.165-2.018-.288q-.001.167.004.345c.004.127.097.228.213.227l6.207-.04c.198-.001.314-.231.228-.413-.813.067-2.886.218-4.634.169",
    fill: "url(#bi)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M59.162 216.135q-.01-.024-.024-.047c-.549-.766-1.945-2.291-4.704-2.953l-1.324-.041s-.59 1.024-.6 2.922c.302.123.887.256 2.018.288 1.747.049 3.82-.102 4.634-.169",
    fill: "url(#bj)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M52.863 211.088c.015.098.196 1.598.267 2.179a.29.29 0 0 0 .243.26c.225.027.59.052.909-.014.172-.035.297-.2.297-.393v-2.353z",
    fill: "url(#bk)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M51.803 183.723s3.193 12.132 3.135 27.4a.59.59 0 0 1-.47.576c-.4.084-.99.185-1.48.171a.55.55 0 0 1-.522-.458c-.447-2.625-3.016-17.413-4.48-19.814 0 0-.963 13.171-.655 20.004a.324.324 0 0 1-.286.337 5.4 5.4 0 0 1-1.188-.003.434.434 0 0 1-.386-.368c-.319-2.222-2.154-15.446-2.076-24.972.004-.538 1.42-2.873 1.42-2.873z",
    fill: "url(#bl)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M62.24 157.596c-1.4 2.608-3.727 5.27-7.511 5.983-3.495.659-9.769 1.472-12.29 1.79a3.1 3.1 0 0 0-1.952 1.048c-1.982 2.294-6.332 8.573-1.212 14.901.655-.364 1.586-.947 2.218-1.621-.567-1.597-.613-3.637.574-6.139q.06.298.152.588c1.636 5.182 1.723 9.495 1.72 10.489a.33.33 0 0 0 .205.307c2.153.863 6.298.349 7.69.142a.47.47 0 0 0 .39-.531c-.682-4.947 2.822-13.085 3.748-15.123.135-.298.374-.538.672-.673 5.293-2.394 7.594-6.08 8.527-9.4-.807-1.084-2.058-1.557-2.93-1.761",
    fill: "url(#bm)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M65.17 159.358c1.13-4.025.251-7.512.251-7.512h-1.206s-.412 2.842-1.975 5.75c.872.205 2.123.678 2.93 1.762",
    fill: "url(#bn)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M64.642 152.487s-1.836-2.378-1.24-3.616c.597-1.239 2.642-1.119 2.642-1.119l.287.971a1.22 1.22 0 0 1-.03.777l-1.13 2.987z",
    fill: "url(#bo)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "m46.161 160.61-.415 4.24s2.385.718 4.12-.506l-1.22-3.853z",
    fill: "url(#bp)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M48.925 155.778c.058.054 2.423 4.699 2.423 4.699l-2.68 1.294-2.896-4.069s2.192-2.829 3.153-1.924",
    fill: "url(#bq)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M46.959 157.814a.43.43 0 0 0 .032.376l1.337 2.228q.03.051.073.092c.16.148.704.579 1.125-.008.358-.5.695-.955 1.056-1.142.21-.11.47-.022.577.19.22.436.647 1.326.915 2.17a.425.425 0 0 1-.248.522c-.543.22-1.615.618-2.568.749a.43.43 0 0 1-.404-.171c-.41-.562-1.564-2.13-1.958-2.522-.366-.365-1.041-.227-1.346-.14a.43.43 0 0 1-.341-.045c-.309-.186-.848-.649-.355-1.433a.43.43 0 0 0-.132-.582c-.345-.226-.72-.652-.363-1.342.361-.698 1.005-.76 1.444-.707a.44.44 0 0 0 .466-.259.28.28 0 0 1 .221-.174.415.415 0 0 0 .336-.487c-.078-.395-.02-.908.611-1.255 1.157-.636 2.17.401 2.428 1.275.257.875-1.036 1.493-1.85 1.596-.597.076-.925.728-1.056 1.069",
    fill: "url(#br)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M47.399 161.116s-.514-1.505-1.173-1.449c-.658.055-1.176.711-.36 1.448 1.014.917 1.533.001 1.533.001",
    fill: "url(#bs)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M41.85 173.171c-.868-2.375-.553-5.243-.55-5.272l.24.028c-.004.028-.312 2.841.536 5.161z",
    fill: "url(#bt)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M47.867 191.288a.12.12 0 0 1-.116-.09c-.265-1.021-2.248-2.143-2.268-2.154a.12.12 0 0 1 .118-.21c.085.048 2.092 1.184 2.382 2.304a.12.12 0 0 1-.116.15",
    fill: "url(#bu)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 11.634,
    y1: 246.722,
    x2: 244.107,
    y2: 77.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 140.481,
    y1: 133.411,
    x2: 164.714,
    y2: 34.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 98.887,
    y1: 148.656,
    x2: 173.658,
    y2: 148.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 119.371,
    y1: 150.459,
    x2: 153.47,
    y2: 150.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 190.555,
    y1: 188.211,
    x2: 235.409,
    y2: 188.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 212.734,
    y1: 176.826,
    x2: 214.572,
    y2: 140.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 193.963,
    y1: 185.002,
    x2: 201.348,
    y2: 185.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 204.35,
    y1: 185.002,
    x2: 211.734,
    y2: 185.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 214.271,
    y1: 185.002,
    x2: 221.656,
    y2: 185.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 230.493,
    y1: 182.698,
    x2: 214.13,
    y2: 201.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 193.963,
    y1: 192.156,
    x2: 201.348,
    y2: 192.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 204.35,
    y1: 192.156,
    x2: 211.734,
    y2: 192.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 214.271,
    y1: 192.156,
    x2: 221.656,
    y2: 192.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 224.656,
    y1: 192.156,
    x2: 232.041,
    y2: 192.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 193.963,
    y1: 199.079,
    x2: 201.348,
    y2: 199.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 204.35,
    y1: 199.079,
    x2: 211.734,
    y2: 199.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 214.271,
    y1: 199.079,
    x2: 221.656,
    y2: 199.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 193.963,
    y1: 206.003,
    x2: 201.348,
    y2: 206.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 204.35,
    y1: 206.003,
    x2: 211.734,
    y2: 206.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 214.271,
    y1: 206.003,
    x2: 221.656,
    y2: 206.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 225.119,
    y1: 202.657,
    x2: 231.119,
    y2: 202.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 186.813,
    y1: 199.641,
    x2: 187.732,
    y2: 219.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 200.743,
    y1: 145.704,
    x2: 192.171,
    y2: 180.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 176.834,
    y1: 175.904,
    x2: 176.527,
    y2: 157.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 176.722,
    y1: 175.899,
    x2: 178.142,
    y2: 195.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 196.049,
    y1: 175.589,
    x2: 195.743,
    y2: 156.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 195.858,
    y1: 174.522,
    x2: 197.278,
    y2: 194.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 187.977,
    y1: 164.909,
    x2: 186.059,
    y2: 178.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 178.934,
    y1: 144.848,
    x2: 178.725,
    y2: 168.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 188.344,
    y1: 179.272,
    x2: 185.483,
    y2: 203.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 198.238,
    y1: 145.081,
    x2: 189.665,
    y2: 179.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 189.066,
    y1: 183.955,
    x2: 186.297,
    y2: 205.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 183.131,
    y1: 201.169,
    x2: 191.183,
    y2: 201.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 112.797,
    y1: 67.657,
    x2: 119.035,
    y2: 67.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 112.73,
    y1: 68.777,
    x2: 119.03,
    y2: 68.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 117.389,
    y1: 68.906,
    x2: 119.034,
    y2: 80.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 102.59,
    y1: 72.857,
    x2: 110.02,
    y2: 72.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 102.274,
    y1: 72.581,
    x2: 109.507,
    y2: 72.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 109.102,
    y1: 70.118,
    x2: 110.747,
    y2: 81.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 120.907,
    y1: 63.534,
    x2: 116.318,
    y2: 89.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 119.316,
    y1: 76.811,
    x2: 128.667,
    y2: 95.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 148.004,
    y1: 74.207,
    x2: 150.698,
    y2: 74.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 148.223,
    y1: 78.522,
    x2: 151.369,
    y2: 78.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 142.059,
    y1: 82.455,
    x2: 115.745,
    y2: 104.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 146.02,
    y1: 73.788,
    x2: 136.52,
    y2: 80.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 157.055,
    y1: 82.709,
    x2: 145.334,
    y2: 92.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 145.754,
    y1: 65.795,
    x2: 149.023,
    y2: 74.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 147.184,
    y1: 64.266,
    x2: 148.634,
    y2: 72.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 144.231,
    y1: 66.368,
    x2: 147.5,
    y2: 75.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 133.242,
    y1: 69.189,
    x2: 150.062,
    y2: 89.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 135.566,
    y1: 82.058,
    x2: 149.419,
    y2: 75.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 138.563,
    y1: 84.302,
    x2: 145.555,
    y2: 77.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 154.546,
    y1: 79.691,
    x2: 142.825,
    y2: 89.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 145.671,
    y1: 83.345,
    x2: 154.59,
    y2: 86.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 157.923,
    y1: 77.497,
    x2: 164.345,
    y2: 84.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 227.184,
    y1: 96.955,
    x2: 237.291,
    y2: 96.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 226.014,
    y1: 103.153,
    x2: 227.06,
    y2: 103.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 197.357,
    y1: 101.319,
    x2: 214.399,
    y2: 101.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 199.693,
    y1: 102.619,
    x2: 216.735,
    y2: 102.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 202.027,
    y1: 103.919,
    x2: 219.069,
    y2: 103.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 204.363,
    y1: 105.218,
    x2: 221.405,
    y2: 105.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 206.701,
    y1: 106.518,
    x2: 223.743,
    y2: 106.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 209.035,
    y1: 107.819,
    x2: 226.077,
    y2: 107.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 211.371,
    y1: 109.119,
    x2: 228.413,
    y2: 109.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 200.268,
    y1: 128.032,
    x2: 217.309,
    y2: 128.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 202.603,
    y1: 129.332,
    x2: 219.645,
    y2: 129.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 204.937,
    y1: 130.631,
    x2: 221.979,
    y2: 130.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 207.273,
    y1: 131.931,
    x2: 224.315,
    y2: 131.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 209.609,
    y1: 133.231,
    x2: 226.651,
    y2: 133.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 211.945,
    y1: 134.532,
    x2: 228.987,
    y2: 134.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 216.195,
    y1: 138.127,
    x2: 233.237,
    y2: 138.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 218.318,
    y1: 139.923,
    x2: 235.36,
    y2: 139.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 214.281,
    y1: 135.832,
    x2: 231.323,
    y2: 135.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 201.85,
    y1: 164.386,
    x2: 204.71,
    y2: 192.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 193.049,
    y1: 167.819,
    x2: 200.062,
    y2: 184.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 202.644,
    y1: 146.184,
    x2: 203.972,
    y2: 161.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aA",
    x1: 195.769,
    y1: 172.247,
    x2: 206.071,
    y2: 187.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aB",
    x1: 209.106,
    y1: 149.233,
    x2: 228.281,
    y2: 183.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aC",
    x1: 208.804,
    y1: 141.964,
    x2: 245.504,
    y2: 177.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aD",
    x1: 212.15,
    y1: 138.355,
    x2: 215.112,
    y2: 147.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aE",
    x1: 1016.06,
    y1: -654.237,
    x2: 1010.74,
    y2: -649.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aF",
    x1: 210.468,
    y1: 123.305,
    x2: 210.42,
    y2: 139.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aG",
    x1: 1016.62,
    y1: -653.67,
    x2: 1011.3,
    y2: -648.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aH",
    x1: 218.479,
    y1: 140.693,
    x2: 216.028,
    y2: 157.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI",
    x1: 219.716,
    y1: 123.705,
    x2: 218.077,
    y2: 141.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aJ",
    x1: 217.569,
    y1: 153.633,
    x2: 209.576,
    y2: 156.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aK",
    x1: 206.59,
    y1: 148.392,
    x2: 200.833,
    y2: 154.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aL",
    x1: 81.322,
    y1: 180.959,
    x2: 70.926,
    y2: 180.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aM",
    x1: 53.363,
    y1: 180.959,
    x2: 35.467,
    y2: 180.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aN",
    x1: 63.959,
    y1: 198.334,
    x2: 61.447,
    y2: 198.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aO",
    x1: 29.277,
    y1: 123.333,
    x2: 110.604,
    y2: 235.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aP",
    x1: 62.732,
    y1: 144.519,
    x2: 82.935,
    y2: 144.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aQ",
    x1: 62.58,
    y1: 146.35,
    x2: 82.745,
    y2: 146.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aR",
    x1: 68.34,
    y1: 148.308,
    x2: 82.615,
    y2: 148.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aS",
    x1: 46.678,
    y1: 153.052,
    x2: 81.59,
    y2: 153.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aT",
    x1: 54.703,
    y1: 155.753,
    x2: 56.443,
    y2: 155.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aU",
    x1: 63.582,
    y1: 161.221,
    x2: 64.51,
    y2: 161.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aV",
    x1: 70.289,
    y1: 159.784,
    x2: 71.316,
    y2: 159.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aW",
    x1: 76.736,
    y1: 162.806,
    x2: 77.665,
    y2: 162.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aX",
    x1: 44.902,
    y1: 154.151,
    x2: 47.675,
    y2: 154.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aY",
    x1: 46.023,
    y1: 144.097,
    x2: 48.458,
    y2: 144.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aZ",
    x1: 43.619,
    y1: 165.062,
    x2: 81.37,
    y2: 165.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 79.547,
    y1: 166.619,
    x2: 81.812,
    y2: 166.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 45.471,
    y1: 214.58,
    x2: 50.092,
    y2: 214.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    x1: 57.041,
    y1: 209.128,
    x2: 40.228,
    y2: 222.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: 79.868,
    y1: 132.702,
    x2: 62.052,
    y2: 151.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: 70.862,
    y1: 144.197,
    x2: 62.035,
    y2: 154.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: 73.565,
    y1: 141.473,
    x2: 68.911,
    y2: 147.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 39.273,
    y1: 182.874,
    x2: 45.437,
    y2: 182.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    x1: 46.757,
    y1: 209.319,
    x2: 45.874,
    y2: 217.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: 60.027,
    y1: 212.933,
    x2: 43.215,
    y2: 226.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    x1: 52.51,
    y1: 214.704,
    x2: 59.162,
    y2: 214.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: 53.947,
    y1: 210.143,
    x2: 53.064,
    y2: 217.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    x1: 64.437,
    y1: 174.915,
    x2: 36.204,
    y2: 218.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bm",
    x1: 44.648,
    y1: 180.211,
    x2: 18.361,
    y2: 237.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bn",
    x1: 68.088,
    y1: 150.811,
    x2: 61.943,
    y2: 159.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bo",
    x1: 65.488,
    y1: 148.966,
    x2: 59.343,
    y2: 157.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp",
    x1: 48.708,
    y1: 159.476,
    x2: 45.337,
    y2: 174.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bq",
    x1: 58.222,
    y1: 151.677,
    x2: 47.394,
    y2: 159.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "br",
    x1: 46.4,
    y1: 161.283,
    x2: 51.296,
    y2: 156.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bs",
    x1: 46.706,
    y1: 167.326,
    x2: 46.411,
    y2: 160.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bt",
    x1: 45.868,
    y1: 162.814,
    x2: 38.891,
    y2: 175.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bu",
    x1: 48.601,
    y1: 186.678,
    x2: 46.234,
    y2: 190.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTransactions);
export default __webpack_public_path__ + "static/media/noTransactions.44faccb6dd3b4c7063b883bed82c5bf7.svg";
export { ForwardRef as ReactComponent };